import { CompanyUserRole } from './graphql';
import { CompanyUserState } from './graphql';
import { DateGranularity } from './graphql';
import { FailedReason } from './graphql';
import { IntegrationState } from './graphql';
import { IntegrationType } from './graphql';
import { InvoiceStatus } from './graphql';
import { NotificationPreferenceType } from './graphql';
import { PreferenceGroup } from './graphql';
import { PreferenceName } from './graphql';
import { ProjectRuleType } from './graphql';
import { ProjectState } from './graphql';
import { QuantitativeQueryMessageFeedback } from './graphql';
import { QueryMessageRole } from './graphql';
import { QueryMessageStatus } from './graphql';
import { SourceType } from './graphql';
import { SubscriptionAction } from './graphql';
import { SubscriptionStatus } from './graphql';
import { SubscriptionType } from './graphql';
import { ThemeType } from './graphql';
import { TokenBillingType } from './graphql';
import { UserCompanyLimitation } from './graphql';
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { User as UserModel, CompanyUser as CompanyUserModel, Token as TokenModel, Query as QueryModel, Project as ProjectModel, Theme as ThemeModel, ProjectRule as ProjectRuleModel, ProjectQuestion as ProjectQuestionModel, Domain as DomainModel, Integration as IntegrationModel, File as FileModel, SourceDocument as SourceDocumentModel, Source as SourceModel, Notification as NotificationModel, NotificationPreference as NotificationPreferenceModel, UserPreference as UserPreferenceModel, Preference as PreferenceModel, CompanySubscription as CompanySubscriptionModel, ProjectRateLimit as ProjectRateLimitModel, Invoice as InvoiceModel } from '@sc/prisma';
import { AuthenticatedUserCompanyWithSubscription as AuthenticatedUserCompanyWithSubscriptionModel, InvocationContext } from '@sc/authentication';
import { QueryMessageResolverType as QueryMessageResolverTypeModel } from '../../../../../apps/api/src/resources/queries/transformers/queryMessage';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type EnumResolverSignature<T, AllowedValues = any> = { [key in keyof T]?: AllowedValues };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTimeISO: { input: string; output: string; }
};

export type AcceptInvitationInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AuthorisationCodeInput = {
  code: Scalars['String']['input'];
  gclid: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  verifier: Scalars['String']['input'];
};

export type AuthorisePayload = {
  __typename?: 'AuthorisePayload';
  accessToken: Scalars['String']['output'];
  registeredCompanyUuid: Maybe<Scalars['String']['output']>;
};

export type BillingDetailsInput = {
  addressLine1: InputMaybe<Scalars['String']['input']>;
  addressLine2: InputMaybe<Scalars['String']['input']>;
  city: InputMaybe<Scalars['String']['input']>;
  enteredCountry: Scalars['String']['input'];
  postcode: InputMaybe<Scalars['String']['input']>;
  vatNumber: InputMaybe<Scalars['String']['input']>;
};

export type BillingUsage = {
  __typename?: 'BillingUsage';
  pages: UsageBalance;
  queries: UsageBalance;
};

export type CompanyUser = {
  __typename?: 'CompanyUser';
  companyUuid: Scalars['String']['output'];
  createdAt: Maybe<Scalars['DateTimeISO']['output']>;
  deletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  invitation: Maybe<CompanyUserInvitation>;
  role: CompanyUserRole;
  user: CompanyUserUser;
  userUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CompanyUserInvitation = {
  __typename?: 'CompanyUserInvitation';
  expiresAt: Scalars['DateTimeISO']['output'];
  uuid: Scalars['String']['output'];
};

export type CompanyUserPage = {
  __typename?: 'CompanyUserPage';
  items: Array<CompanyUser>;
  pagination: PaginationResponse;
};

export { CompanyUserRole };

export { CompanyUserState };

export type CompanyUserUser = {
  __typename?: 'CompanyUserUser';
  email: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ConfirmEmailInput = {
  email: Scalars['String']['input'];
  verification: Scalars['String']['input'];
};

export type CreateDomainInput = {
  url: Scalars['String']['input'];
};

export type CreateFile = {
  __typename?: 'CreateFile';
  src: Scalars['String']['output'];
  uploadInstructions: UploadInstructions;
  uuid: Scalars['String']['output'];
};

export type CreateFileInput = {
  files: Array<CreateFileInputFiles>;
  keyPrefix: Scalars['String']['input'];
  projectUuid: InputMaybe<Scalars['String']['input']>;
};

export type CreateFileInputFiles = {
  deletedAt: InputMaybe<Scalars['DateTimeISO']['input']>;
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  uuid: InputMaybe<Scalars['String']['input']>;
};

export type CreateIntegrationInput = {
  authorisationCode: Scalars['String']['input'];
  integrationType: IntegrationType;
};

export type CreateInvitationForUserInput = {
  email: Scalars['String']['input'];
  role: CompanyUserRole;
};

export type CreateNotificationPreferenceInput = {
  isEmail: Scalars['Boolean']['input'];
  isWeb: Scalars['Boolean']['input'];
  notificationType: NotificationPreferenceType;
  notificationValue: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectInput = {
  name: Scalars['String']['input'];
};

export type CreateQueryInput = {
  content: Scalars['String']['input'];
  fileUuids: Array<Scalars['String']['input']>;
  projectUuid: Scalars['String']['input'];
  question: InputMaybe<Scalars['String']['input']>;
};

export type CreateQueryMessageFileInput = {
  key: Scalars['String']['input'];
  keyPrefix: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type CreateQueryMessageInput = {
  content: Scalars['String']['input'];
  fileUuids: Array<Scalars['String']['input']>;
  queryUuid: Scalars['String']['input'];
};

export type CreateQueryMessageResponse = {
  __typename?: 'CreateQueryMessageResponse';
  model: QueryMessage;
  user: QueryMessage;
};

export type CreateQueryResponse = {
  __typename?: 'CreateQueryResponse';
  model: QueryMessage;
  query: ProjectQuery;
  user: QueryMessage;
};

export type CreateSessionTokenInput = {
  domainPrefix: InputMaybe<Scalars['String']['input']>;
  hostname: Scalars['String']['input'];
  magicLink: InputMaybe<MagicLinkInput>;
};

export type CreateSubscriptionIntentInput = {
  paymentMethodId: InputMaybe<Scalars['String']['input']>;
  paymentMethodUuid: InputMaybe<Scalars['String']['input']>;
  priceStep: Scalars['Int']['input'];
  subscriptionType: SubscriptionType;
};

export type CreateThemeInput = {
  brandColour: Scalars['String']['input'];
  logoUuid: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subtitle: InputMaybe<Scalars['String']['input']>;
  themeType: ThemeType;
  title: InputMaybe<Scalars['String']['input']>;
};

export { DateGranularity };

export type DateWithCount = {
  __typename?: 'DateWithCount';
  count: Scalars['Int']['output'];
  date: Scalars['DateTimeISO']['output'];
};

export type DeleteDomainInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteNotificationPreferenceInput = {
  uuid: Scalars['String']['input'];
};

export type DeleteUserInput = {
  userUuid: Scalars['String']['input'];
};

export type DimensionInput = {
  height: InputMaybe<Scalars['Int']['input']>;
  width: Scalars['Int']['input'];
};

export type Domain = {
  __typename?: 'Domain';
  cloudflareStatus: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  projectUuid: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  verificationRecords: Array<DomainVerificationRecord>;
};

export type DomainPage = {
  __typename?: 'DomainPage';
  items: Array<Domain>;
  pagination: PaginationResponse;
};

export type DomainVerificationRecord = {
  __typename?: 'DomainVerificationRecord';
  name: Scalars['String']['output'];
  purpose: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export { FailedReason };

export type File = {
  __typename?: 'File';
  createdAt: Scalars['DateTimeISO']['output'];
  downloadSrc: Scalars['String']['output'];
  key: Scalars['String']['output'];
  keyPrefix: Maybe<Scalars['String']['output']>;
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  src: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};


export type FileSrcArgs = {
  input: InputMaybe<DimensionInput>;
};

export type IndexDomainsFilterInput = {
  unallocated: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndexDomainsInput = {
  filters: InputMaybe<IndexDomainsFilterInput>;
  pagination: PaginationInput;
};

export type IndexGroundingChunksInput = {
  message: ReadQueryMessageInput;
  queryUuid: Scalars['String']['input'];
};

export type IndexIntegrationDocumentsInput = {
  nextPageToken: InputMaybe<Scalars['String']['input']>;
  pathSegments: Array<IntegrationDocumentsPagePathSegmentInput>;
  query: InputMaybe<Scalars['String']['input']>;
  type: IntegrationType;
};

export type IndexIntegrationInput = {
  pagination: InputMaybe<PaginationInput>;
};

export type IndexProjectsInput = {
  filter: IndexProjectsInputFilter;
  pagination: InputMaybe<PaginationInput>;
};

export type IndexProjectsInputFilter = {
  state: InputMaybe<ProjectState>;
};

export type IndexQueryInput = {
  filter: IndexQueryInputFilter;
  pagination: PaginationInput;
};

export type IndexQueryInputFilter = {
  isBookmarked: InputMaybe<Scalars['Boolean']['input']>;
  projectUuid: Scalars['String']['input'];
};

export type IndexQueryMessagesFilter = {
  queryUuid: Scalars['String']['input'];
};

export type IndexQueryMessagesInput = {
  filter: IndexQueryMessagesFilter;
  lastEvaluatedKey: InputMaybe<Scalars['String']['input']>;
};

export type IndexSourceDocumentsInput = {
  filter: ReadSourceDocumentsFilter;
  pagination: PaginationInput;
};

export type IndexThemesInput = {
  pagination: InputMaybe<PaginationInput>;
};

export type IndexUserPreferencesInput = {
  filter: IndexUserPreferencesInputFilter;
};

export type IndexUserPreferencesInputFilter = {
  group: InputMaybe<PreferenceGroup>;
};

export type IndexUsersInput = {
  filter: IndexUsersInputFilter;
  pagination: InputMaybe<PaginationInput>;
};

export type IndexUsersInputFilter = {
  state: InputMaybe<CompanyUserState>;
};

export type Integration = {
  __typename?: 'Integration';
  state: IntegrationState;
  type: IntegrationType;
  uuid: Scalars['String']['output'];
};

export type IntegrationDocument = {
  __typename?: 'IntegrationDocument';
  hasChildren: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pathSegments: Array<IntegrationDocumentsPagePathSegment>;
  relevance: Scalars['DateTimeISO']['output'];
  type: Scalars['String']['output'];
};

export type IntegrationDocumentsPage = {
  __typename?: 'IntegrationDocumentsPage';
  items: Array<IntegrationDocument>;
  nextPageToken: Maybe<Scalars['String']['output']>;
  pathSegments: Array<IntegrationDocumentsPagePathSegment>;
  totalPages: Maybe<Scalars['Int']['output']>;
};

export type IntegrationDocumentsPagePathSegment = {
  __typename?: 'IntegrationDocumentsPagePathSegment';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Maybe<Scalars['String']['output']>;
};

export type IntegrationDocumentsPagePathSegmentInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationPage = {
  __typename?: 'IntegrationPage';
  items: Array<Integration>;
  pagination: PaginationResponse;
};

export type IntegrationSelectionResolution = {
  __typename?: 'IntegrationSelectionResolution';
  count: Scalars['Int']['output'];
};

export { IntegrationState };

export { IntegrationType };

export type Invoice = {
  __typename?: 'Invoice';
  createdAt: Scalars['DateTimeISO']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  paidAt: Maybe<Scalars['DateTimeISO']['output']>;
  status: InvoiceStatus;
  stripeDetails: Maybe<InvoiceStripeDetails>;
  subscriptionType: Maybe<SubscriptionType>;
  subtotal: Maybe<Scalars['Float']['output']>;
  tax: Maybe<Scalars['Float']['output']>;
  total: Maybe<Scalars['Float']['output']>;
  uuid: Scalars['String']['output'];
};

export type InvoicePage = {
  __typename?: 'InvoicePage';
  items: Array<Invoice>;
  pagination: PaginationResponse;
};

export { InvoiceStatus };

export type InvoiceStripeDetails = {
  __typename?: 'InvoiceStripeDetails';
  dueDate: Maybe<Scalars['DateTimeISO']['output']>;
  hostedInvoiceUrl: Maybe<Scalars['String']['output']>;
  invoicePdfUrl: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['String']['output']>;
  paymentMethodBrand: Maybe<Scalars['String']['output']>;
  paymentMethodLast4: Maybe<Scalars['String']['output']>;
};

export type ListInvoicesInput = {
  pagination: InputMaybe<PaginationInput>;
};

export type MagicLinkInput = {
  token: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvitation: Token;
  authoriseWithAuthorisationCode: AuthorisePayload;
  confirmEmail: Scalars['Boolean']['output'];
  createDomain: Domain;
  createFile: Array<CreateFile>;
  createIntegration: Maybe<Scalars['Boolean']['output']>;
  createInvitationForUser: CompanyUser;
  createNotificationPreference: NotificationPreference;
  createProject: Project;
  createQuery: CreateQueryResponse;
  createQueryMessage: CreateQueryMessageResponse;
  createSessionToken: SessionToken;
  createSetupIntent: StripeIntent;
  createSubscriptionIntent: PaymentResult;
  createTheme: Theme;
  deleteCompany: Scalars['Boolean']['output'];
  deleteDomain: Scalars['Boolean']['output'];
  deleteFile: Scalars['Boolean']['output'];
  deleteMe: Scalars['Boolean']['output'];
  deleteNotificationPreference: Scalars['Boolean']['output'];
  deleteTheme: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  generateProjectQuestions: Project;
  payInvoice: PaymentResult;
  register: RegisterPayload;
  removePaymentMethod: Scalars['Boolean']['output'];
  requestLoginMagicLink: Scalars['Boolean']['output'];
  requestMagicLink: Scalars['Boolean']['output'];
  resendInvite: CompanyUser;
  resendVerificationEmail: Scalars['Boolean']['output'];
  resolveIntegrationSelection: IntegrationSelectionResolution;
  savePaymentMethod: PaymentMethod;
  sendDomainVerificationEmail: Scalars['Boolean']['output'];
  updateBillingDetails: UpdateBillingDetailsResult;
  updateCompany: UserCompany;
  updateMe: User;
  updateNotification: Notification;
  updateNotificationPreference: NotificationPreference;
  updateProject: Project;
  updateQuery: ProjectQuery;
  updateQueryMessage: Scalars['Boolean']['output'];
  updateRateLimit: ProjectRateLimit;
  updateSource: Source;
  updateSourceDocuments: Scalars['Boolean']['output'];
  updateSubscription: Scalars['Boolean']['output'];
  updateTheme: Theme;
  updateUser: CompanyUser;
  updateUserPreference: UserPreference;
  verifyLoginMagicLink: Token;
};


export type MutationAcceptInvitationArgs = {
  input: AcceptInvitationInput;
};


export type MutationAuthoriseWithAuthorisationCodeArgs = {
  input: AuthorisationCodeInput;
};


export type MutationConfirmEmailArgs = {
  input: ConfirmEmailInput;
};


export type MutationCreateDomainArgs = {
  input: CreateDomainInput;
};


export type MutationCreateFileArgs = {
  input: CreateFileInput;
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateInvitationForUserArgs = {
  input: CreateInvitationForUserInput;
};


export type MutationCreateNotificationPreferenceArgs = {
  input: CreateNotificationPreferenceInput;
};


export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


export type MutationCreateQueryArgs = {
  input: CreateQueryInput;
};


export type MutationCreateQueryMessageArgs = {
  input: CreateQueryMessageInput;
};


export type MutationCreateSessionTokenArgs = {
  input: CreateSessionTokenInput;
};


export type MutationCreateSubscriptionIntentArgs = {
  input: CreateSubscriptionIntentInput;
};


export type MutationCreateThemeArgs = {
  input: CreateThemeInput;
};


export type MutationDeleteDomainArgs = {
  input: DeleteDomainInput;
};


export type MutationDeleteFileArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteNotificationPreferenceArgs = {
  input: DeleteNotificationPreferenceInput;
};


export type MutationDeleteThemeArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationGenerateProjectQuestionsArgs = {
  projectUuid: Scalars['String']['input'];
};


export type MutationPayInvoiceArgs = {
  input: PayInvoiceInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemovePaymentMethodArgs = {
  input: RemovePaymentMethodInput;
};


export type MutationRequestLoginMagicLinkArgs = {
  input: RequestLoginMagicLinkInput;
};


export type MutationRequestMagicLinkArgs = {
  input: RequestMagicLinkInput;
};


export type MutationResendInviteArgs = {
  input: ResendInviteInput;
};


export type MutationResolveIntegrationSelectionArgs = {
  input: ResolveIntegrationSelectionInput;
};


export type MutationSavePaymentMethodArgs = {
  input: SavePaymentMethodInput;
};


export type MutationSendDomainVerificationEmailArgs = {
  input: SendDomainVerificationEmailInput;
};


export type MutationUpdateBillingDetailsArgs = {
  input: BillingDetailsInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateNotificationArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateNotificationPreferenceArgs = {
  input: UpdateNotificationPreferenceInput;
};


export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


export type MutationUpdateQueryArgs = {
  input: UpdateQueryInput;
};


export type MutationUpdateQueryMessageArgs = {
  input: UpdateQueryMessageInput;
};


export type MutationUpdateRateLimitArgs = {
  input: UpdateRateLimit;
};


export type MutationUpdateSourceArgs = {
  input: UpdateSourceInput;
};


export type MutationUpdateSourceDocumentsArgs = {
  input: UpdateSourceDocumentsInput;
};


export type MutationUpdateSubscriptionArgs = {
  action: SubscriptionAction;
};


export type MutationUpdateThemeArgs = {
  input: UpdateThemeInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserPreferenceArgs = {
  input: UpdateUserPreferenceInput;
};


export type MutationVerifyLoginMagicLinkArgs = {
  input: VerifyLoginMagicLinkInput;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  isDismissed: Scalars['Boolean']['output'];
  isViewed: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  title: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  isEmail: Scalars['Boolean']['output'];
  isWeb: Scalars['Boolean']['output'];
  notificationType: NotificationPreferenceType;
  notificationValue: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export { NotificationPreferenceType };

export type OutstandingInvoice = {
  __typename?: 'OutstandingInvoice';
  subscriptionUuid: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type PaginationCursorInput = {
  perPage: Scalars['Int']['input'];
  token: InputMaybe<Scalars['String']['input']>;
};

export type PaginationCursorResponse = {
  __typename?: 'PaginationCursorResponse';
  nextPageToken: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};

export type PaginationResponse = {
  __typename?: 'PaginationResponse';
  currentPage: Scalars['Int']['output'];
  from: Scalars['Int']['output'];
  lastPage: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  to: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PayInvoiceInput = {
  invoiceUuid: Scalars['String']['input'];
  paymentMethodId: InputMaybe<Scalars['String']['input']>;
  paymentMethodUuid: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  brand: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
  useForMonthlyPlan: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type PaymentResult = {
  __typename?: 'PaymentResult';
  clientSecret: Maybe<Scalars['String']['output']>;
  succeeded: Scalars['Boolean']['output'];
};

export type PlanChangePreview = {
  __typename?: 'PlanChangePreview';
  charge: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
};

export type Preference = {
  __typename?: 'Preference';
  displayName: Scalars['String']['output'];
  group: PreferenceGroup;
  name: PreferenceName;
  uuid: Scalars['String']['output'];
};

export { PreferenceGroup };

export { PreferenceName };

export type Project = {
  __typename?: 'Project';
  createdAt: Scalars['DateTimeISO']['output'];
  dailyQueryCount: Scalars['Int']['output'];
  domainPrefix: Scalars['String']['output'];
  domains: Array<ProjectDomain>;
  name: Scalars['String']['output'];
  processedAt: Maybe<Scalars['DateTimeISO']['output']>;
  processedPc: Scalars['Float']['output'];
  questions: Array<ProjectQuestion>;
  rules: Array<ProjectRule>;
  sourceCount: Scalars['Int']['output'];
  state: ProjectState;
  subtitle: Maybe<Scalars['String']['output']>;
  theme: Maybe<ProjectTheme>;
  title: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ProjectDomain = {
  __typename?: 'ProjectDomain';
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ProjectPage = {
  __typename?: 'ProjectPage';
  items: Array<Project>;
  pagination: PaginationResponse;
};

export type ProjectQuery = {
  __typename?: 'ProjectQuery';
  isBookmarked: Scalars['Boolean']['output'];
  rateLimit: SessionRateLimit;
  title: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ProjectQuestion = {
  __typename?: 'ProjectQuestion';
  question: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ProjectRateLimit = {
  __typename?: 'ProjectRateLimit';
  queriesPerUserPerHour: Scalars['Int']['output'];
  queryMultiplier: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
};

export type ProjectRule = {
  __typename?: 'ProjectRule';
  type: ProjectRuleType;
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export { ProjectRuleType };

export { ProjectState };

export type ProjectTheme = {
  __typename?: 'ProjectTheme';
  brandColour: Scalars['String']['output'];
  logoSrc: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subtitle: Maybe<Scalars['String']['output']>;
  themeType: ThemeType;
  title: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export { QuantitativeQueryMessageFeedback };

export type Query = {
  __typename?: 'Query';
  countQueries: Array<DateWithCount>;
  countUsageSummary: UsageSummary;
  indexDomains: DomainPage;
  indexGroundingChunks: Array<QueryMessageGroundingChunk>;
  indexIntegrationDocuments: IntegrationDocumentsPage;
  indexIntegrations: IntegrationPage;
  indexNotifications: Array<Notification>;
  indexProjects: ProjectPage;
  indexQueries: QueryPage;
  indexQueryMessages: QueryMessagePage;
  indexSourceDocuments: SourceDocumentPage;
  indexSources: Array<Source>;
  indexThemes: ThemePage;
  indexUserPreferences: Array<UserPreference>;
  indexUsers: CompanyUserPage;
  listInvoices: InvoicePage;
  listPaymentMethods: Array<PaymentMethod>;
  logout: Scalars['Boolean']['output'];
  me: User;
  notificationPreferences: Array<NotificationPreference>;
  previewPlanChange: PlanChangePreview;
  readChatQuestions: Array<Scalars['String']['output']>;
  readDomain: Domain;
  readIntegration: Maybe<Integration>;
  readIntegrationAccessToken: Maybe<Scalars['String']['output']>;
  readInvoice: Invoice;
  readProject: Project;
  readQuery: Maybe<ProjectQuery>;
  readQueryMessage: QueryMessage;
  readRateLimit: ProjectRateLimit;
  readSource: Source;
  readTheme: Theme;
  readUsage: BillingUsage;
};


export type QueryCountQueriesArgs = {
  dates: Array<Scalars['DateTimeISO']['input']>;
  granularity: InputMaybe<DateGranularity>;
  unique: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryIndexDomainsArgs = {
  input: IndexDomainsInput;
};


export type QueryIndexGroundingChunksArgs = {
  input: IndexGroundingChunksInput;
};


export type QueryIndexIntegrationDocumentsArgs = {
  input: IndexIntegrationDocumentsInput;
};


export type QueryIndexIntegrationsArgs = {
  input: InputMaybe<IndexIntegrationInput>;
};


export type QueryIndexProjectsArgs = {
  input: IndexProjectsInput;
};


export type QueryIndexQueriesArgs = {
  input: IndexQueryInput;
};


export type QueryIndexQueryMessagesArgs = {
  input: IndexQueryMessagesInput;
};


export type QueryIndexSourceDocumentsArgs = {
  input: IndexSourceDocumentsInput;
};


export type QueryIndexSourcesArgs = {
  projectUuid: Scalars['String']['input'];
};


export type QueryIndexThemesArgs = {
  input: IndexThemesInput;
};


export type QueryIndexUserPreferencesArgs = {
  input: IndexUserPreferencesInput;
};


export type QueryIndexUsersArgs = {
  input: IndexUsersInput;
};


export type QueryListInvoicesArgs = {
  input: ListInvoicesInput;
};


export type QueryPreviewPlanChangeArgs = {
  priceStep: Scalars['Int']['input'];
};


export type QueryReadDomainArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryReadIntegrationArgs = {
  type: IntegrationType;
};


export type QueryReadIntegrationAccessTokenArgs = {
  type: IntegrationType;
};


export type QueryReadInvoiceArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryReadProjectArgs = {
  createdAt: InputMaybe<Scalars['DateTimeISO']['input']>;
  uuid: Scalars['String']['input'];
};


export type QueryReadQueryArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryReadQueryMessageArgs = {
  input: ReadQueryMessageInput;
};


export type QueryReadRateLimitArgs = {
  projectUuid: Scalars['String']['input'];
};


export type QueryReadSourceArgs = {
  input: ReadSourceInput;
};


export type QueryReadThemeArgs = {
  uuid: Scalars['String']['input'];
};

export type QueryMessage = {
  __typename?: 'QueryMessage';
  citations: Array<QueryMessageCitation>;
  createdAt: Scalars['DateTimeISO']['output'];
  feedback: Maybe<QueryMessageFeedback>;
  files: Array<File>;
  groundingChunks: Array<QueryMessageGroundingChunk>;
  parts: Array<QueryMessagePart>;
  retrievalToken: Maybe<Scalars['String']['output']>;
  role: QueryMessageRole;
  status: QueryMessageStatus;
  uuid: Scalars['String']['output'];
};

export type QueryMessageCitation = {
  __typename?: 'QueryMessageCitation';
  chunkId: Scalars['String']['output'];
  endIndex: Maybe<Scalars['Int']['output']>;
  snippet: Scalars['String']['output'];
  startIndex: Maybe<Scalars['Int']['output']>;
};

export type QueryMessageFeedback = {
  __typename?: 'QueryMessageFeedback';
  qualitative: Maybe<Scalars['String']['output']>;
  quantitative: QuantitativeQueryMessageFeedback;
};

export type QueryMessageGroundingChunk = {
  __typename?: 'QueryMessageGroundingChunk';
  description: Maybe<Scalars['String']['output']>;
  favicon: Maybe<Scalars['String']['output']>;
  file: Maybe<QueryMessageGroundingChunkFile>;
  hostedIntegrationPath: Maybe<Scalars['String']['output']>;
  source: QueryMessageGroundingChunkSource;
  title: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type QueryMessageGroundingChunkFile = {
  __typename?: 'QueryMessageGroundingChunkFile';
  name: Scalars['String']['output'];
};

export type QueryMessageGroundingChunkSource = {
  __typename?: 'QueryMessageGroundingChunkSource';
  type: SourceType;
};

export type QueryMessagePage = {
  __typename?: 'QueryMessagePage';
  items: Array<QueryMessage>;
  lastEvaluatedKey: Maybe<Scalars['String']['output']>;
};

export type QueryMessagePart = {
  __typename?: 'QueryMessagePart';
  executableCode: Maybe<QueryMessagePartExecutableCode>;
  text: Maybe<Scalars['String']['output']>;
  thought: Maybe<Scalars['Boolean']['output']>;
};

export type QueryMessagePartExecutableCode = {
  __typename?: 'QueryMessagePartExecutableCode';
  code: Maybe<Scalars['String']['output']>;
  language: Maybe<Scalars['String']['output']>;
};

export { QueryMessageRole };

export { QueryMessageStatus };

export type QueryPage = {
  __typename?: 'QueryPage';
  items: Array<ProjectQuery>;
  pagination: PaginationResponse;
};

export type ReadQueryMessageInput = {
  createdAt: Scalars['DateTimeISO']['input'];
  uuid: Scalars['String']['input'];
};

export type ReadSourceDocumentsFilter = {
  sourceUuid: Scalars['String']['input'];
};

export type ReadSourceInput = {
  projectUuid: Scalars['String']['input'];
  type: SourceType;
};

export type RegisterInput = {
  email: Scalars['String']['input'];
  gclid: InputMaybe<Scalars['String']['input']>;
};

export type RegisterPayload = {
  __typename?: 'RegisterPayload';
  accessToken: Scalars['String']['output'];
  companyUuid: Scalars['String']['output'];
};

export type RemovePaymentMethodInput = {
  paymentMethodUuid: Scalars['String']['input'];
};

export type RequestLoginMagicLinkInput = {
  email: Scalars['String']['input'];
  /**
   * Binds the link to the requesting browser. Omitted when the browser cannot
   * persist the nonce cookie, in which case the link is redeemable anywhere.
   */
  nonce: InputMaybe<Scalars['String']['input']>;
};

export type RequestMagicLinkInput = {
  domainPrefix: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
};

export type ResendInviteInput = {
  userUuid: Scalars['String']['input'];
};

export type ResolveIntegrationSelectionInput = {
  documentType: Scalars['String']['input'];
  id: Scalars['String']['input'];
  sourceUuid: Scalars['String']['input'];
  type: IntegrationType;
};

export type SavePaymentMethodInput = {
  billingDetails: InputMaybe<BillingDetailsInput>;
  paymentMethodId: InputMaybe<Scalars['String']['input']>;
  paymentMethodUuid: InputMaybe<Scalars['String']['input']>;
  useForMonthlyPlan: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendDomainVerificationEmailInput = {
  email: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type SessionRateLimit = {
  __typename?: 'SessionRateLimit';
  queriesConsumed: Scalars['Float']['output'];
  queriesPerUserPerHour: Scalars['Int']['output'];
  queriesRemaining: Scalars['Int']['output'];
  queriesUsedThisHour: Scalars['Int']['output'];
  queryMultiplier: Scalars['Int']['output'];
  resetsAt: Maybe<Scalars['DateTimeISO']['output']>;
};

export type SessionToken = {
  __typename?: 'SessionToken';
  accessToken: Scalars['String']['output'];
};

export type Source = {
  __typename?: 'Source';
  documentCount: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  type: SourceType;
  uuid: Scalars['String']['output'];
};

export type SourceDocument = {
  __typename?: 'SourceDocument';
  description: Maybe<Scalars['String']['output']>;
  failedAt: Maybe<Scalars['DateTimeISO']['output']>;
  failedReason: Maybe<FailedReason>;
  file: Maybe<File>;
  hostedIntegrationDocumentId: Maybe<Scalars['String']['output']>;
  hostedIntegrationPath: Maybe<Scalars['String']['output']>;
  processedAt: Maybe<Scalars['DateTimeISO']['output']>;
  thumbnail: Maybe<File>;
  title: Scalars['String']['output'];
  url: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type SourceDocumentPage = {
  __typename?: 'SourceDocumentPage';
  items: Array<SourceDocument>;
  pagination: PaginationResponse;
};

export { SourceType };

export type StripeIntent = {
  __typename?: 'StripeIntent';
  clientSecret: Scalars['String']['output'];
};

export { SubscriptionAction };

export { SubscriptionStatus };

export { SubscriptionType };

export type Theme = {
  __typename?: 'Theme';
  brandColour: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  logo: File;
  name: Scalars['String']['output'];
  projectCount: Scalars['Int']['output'];
  subtitle: Maybe<Scalars['String']['output']>;
  themeType: ThemeType;
  title: Maybe<Scalars['String']['output']>;
  used: Scalars['Boolean']['output'];
  uuid: Scalars['String']['output'];
};

export type ThemePage = {
  __typename?: 'ThemePage';
  items: Array<Theme>;
  pagination: PaginationResponse;
};

export { ThemeType };

export type Token = {
  __typename?: 'Token';
  accessToken: Scalars['String']['output'];
};

export { TokenBillingType };

export type UpdateBillingDetailsResult = {
  __typename?: 'UpdateBillingDetailsResult';
  company: UserCompany;
  removedPaymentMethods: Scalars['Int']['output'];
};

export type UpdateCompanyInput = {
  name: Scalars['String']['input'];
};

export type UpdateMeInput = {
  email: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNotificationInput = {
  isDismissed: InputMaybe<Scalars['Boolean']['input']>;
  isViewed: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateNotificationPreferenceInput = {
  isEmail: Scalars['Boolean']['input'];
  isWeb: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateProjectInput = {
  customDomainUuids: InputMaybe<Array<Scalars['String']['input']>>;
  name: InputMaybe<Scalars['String']['input']>;
  questions: InputMaybe<Array<UpdateProjectQuestionInput>>;
  rules: InputMaybe<Array<UpdateProjectRuleInput>>;
  state: InputMaybe<ProjectState>;
  subtitle: InputMaybe<Scalars['String']['input']>;
  themeUuid: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateProjectQuestionInput = {
  question: Scalars['String']['input'];
};

export type UpdateProjectRuleInput = {
  type: ProjectRuleType;
  value: Scalars['String']['input'];
};

export type UpdateQueryInput = {
  generateTitle: InputMaybe<Scalars['String']['input']>;
  isBookmarked: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateQueryMessageInput = {
  createdAt: Scalars['DateTimeISO']['input'];
  feedback: InputMaybe<QuantitativeQueryMessageFeedback>;
  queryUuid: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateRateLimit = {
  projectUuid: Scalars['String']['input'];
  queriesPerUserPerHour: InputMaybe<Scalars['Int']['input']>;
  queryMultiplier: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSourceDocumentsDocumentInput = {
  description: InputMaybe<Scalars['String']['input']>;
  fileUuid: InputMaybe<Scalars['String']['input']>;
  hostedIntegrationDocumentId: InputMaybe<Scalars['String']['input']>;
  hostedIntegrationDocumentPath: InputMaybe<Scalars['String']['input']>;
  hostedIntegrationMimeType: InputMaybe<Scalars['String']['input']>;
  relevance: Scalars['DateTimeISO']['input'];
  thumbnailUuid: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSourceDocumentsInput = {
  documentsToCreate: Array<UpdateSourceDocumentsDocumentInput>;
  documentsToDelete: Array<Scalars['String']['input']>;
  integrationType: InputMaybe<IntegrationType>;
  uuid: Scalars['String']['input'];
};

export type UpdateSourceInput = {
  name: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateThemeInput = {
  brandColour: InputMaybe<Scalars['String']['input']>;
  logoUuid: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  subtitle: InputMaybe<Scalars['String']['input']>;
  themeType: InputMaybe<ThemeType>;
  title: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateUserInput = {
  email: InputMaybe<Scalars['String']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  role: InputMaybe<CompanyUserRole>;
  userUuid: Scalars['String']['input'];
};

export type UpdateUserPreferenceInput = {
  group: PreferenceGroup;
  name: PreferenceName;
  value: InputMaybe<Scalars['String']['input']>;
};

export type UploadInstructions = {
  __typename?: 'UploadInstructions';
  key: Scalars['String']['output'];
  keyPrefix: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UsageBalance = {
  __typename?: 'UsageBalance';
  total: Scalars['Int']['output'];
  used: Scalars['Int']['output'];
};

export type UsageSummary = {
  __typename?: 'UsageSummary';
  pages: UsageSummaryMetric;
  queries: UsageSummaryMetric;
  users: UsageSummaryMetric;
};

export type UsageSummaryMetric = {
  __typename?: 'UsageSummaryMetric';
  current: Scalars['Int']['output'];
  previous: Scalars['Int']['output'];
  sparkline: Array<Scalars['Int']['output']>;
};

export type User = {
  __typename?: 'User';
  company: UserCompany;
  email: Scalars['String']['output'];
  hasPendingEmail: Maybe<Scalars['Boolean']['output']>;
  name: Maybe<Scalars['String']['output']>;
  onboardingCompletedAt: Maybe<Scalars['DateTimeISO']['output']>;
  pendingEmail: Maybe<Scalars['String']['output']>;
  role: CompanyUserRole;
  unreadNotificationCount: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
  verifiedEmailAt: Maybe<Scalars['DateTimeISO']['output']>;
};

export type UserCompany = {
  __typename?: 'UserCompany';
  billingAddressLine1: Maybe<Scalars['String']['output']>;
  billingAddressLine2: Maybe<Scalars['String']['output']>;
  billingCity: Maybe<Scalars['String']['output']>;
  billingCountry: Maybe<Scalars['String']['output']>;
  billingPostalCode: Maybe<Scalars['String']['output']>;
  limitations: Array<UserCompanyLimitation>;
  name: Maybe<Scalars['String']['output']>;
  outstandingInvoice: Maybe<OutstandingInvoice>;
  subscription: Maybe<UserCompanySubscription>;
  uuid: Scalars['String']['output'];
  vatNumber: Maybe<Scalars['String']['output']>;
};

export { UserCompanyLimitation };

export type UserCompanySubscription = {
  __typename?: 'UserCompanySubscription';
  expiresAt: Maybe<Scalars['DateTimeISO']['output']>;
  renewsAt: Maybe<Scalars['DateTimeISO']['output']>;
  status: SubscriptionStatus;
  subtotal: Scalars['Float']['output'];
  tokenBillingType: TokenBillingType;
  type: SubscriptionType;
  uuid: Scalars['String']['output'];
};

export type UserPreference = {
  __typename?: 'UserPreference';
  preference: Preference;
  preferenceUuid: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
  value: Maybe<Scalars['String']['output']>;
};

export type VerifyLoginMagicLinkInput = {
  nonce: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;

export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;





/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AcceptInvitationInput: AcceptInvitationInput;
  AuthorisationCodeInput: AuthorisationCodeInput;
  AuthorisePayload: ResolverTypeWrapper<AuthorisePayload>;
  BillingDetailsInput: BillingDetailsInput;
  BillingUsage: ResolverTypeWrapper<BillingUsage>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CompanyUser: ResolverTypeWrapper<CompanyUserModel>;
  CompanyUserInvitation: ResolverTypeWrapper<TokenModel>;
  CompanyUserPage: ResolverTypeWrapper<Omit<CompanyUserPage, 'items'> & { items: Array<ResolversTypes['CompanyUser']> }>;
  CompanyUserRole: CompanyUserRole;
  CompanyUserState: CompanyUserState;
  CompanyUserUser: ResolverTypeWrapper<UserModel>;
  ConfirmEmailInput: ConfirmEmailInput;
  CreateDomainInput: CreateDomainInput;
  CreateFile: ResolverTypeWrapper<CreateFile>;
  CreateFileInput: CreateFileInput;
  CreateFileInputFiles: CreateFileInputFiles;
  CreateIntegrationInput: CreateIntegrationInput;
  CreateInvitationForUserInput: CreateInvitationForUserInput;
  CreateNotificationPreferenceInput: CreateNotificationPreferenceInput;
  CreateProjectInput: CreateProjectInput;
  CreateQueryInput: CreateQueryInput;
  CreateQueryMessageFileInput: CreateQueryMessageFileInput;
  CreateQueryMessageInput: CreateQueryMessageInput;
  CreateQueryMessageResponse: ResolverTypeWrapper<Omit<CreateQueryMessageResponse, 'model' | 'user'> & { model: ResolversTypes['QueryMessage'], user: ResolversTypes['QueryMessage'] }>;
  CreateQueryResponse: ResolverTypeWrapper<Omit<CreateQueryResponse, 'model' | 'query' | 'user'> & { model: ResolversTypes['QueryMessage'], query: ResolversTypes['ProjectQuery'], user: ResolversTypes['QueryMessage'] }>;
  CreateSessionTokenInput: CreateSessionTokenInput;
  CreateSubscriptionIntentInput: CreateSubscriptionIntentInput;
  CreateThemeInput: CreateThemeInput;
  DateGranularity: DateGranularity;
  DateTimeISO: ResolverTypeWrapper<Scalars['DateTimeISO']['output']>;
  DateWithCount: ResolverTypeWrapper<DateWithCount>;
  DeleteDomainInput: DeleteDomainInput;
  DeleteNotificationPreferenceInput: DeleteNotificationPreferenceInput;
  DeleteUserInput: DeleteUserInput;
  DimensionInput: DimensionInput;
  Domain: ResolverTypeWrapper<DomainModel>;
  DomainPage: ResolverTypeWrapper<Omit<DomainPage, 'items'> & { items: Array<ResolversTypes['Domain']> }>;
  DomainVerificationRecord: ResolverTypeWrapper<DomainVerificationRecord>;
  FailedReason: FailedReason;
  File: ResolverTypeWrapper<FileModel>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  IndexDomainsFilterInput: IndexDomainsFilterInput;
  IndexDomainsInput: IndexDomainsInput;
  IndexGroundingChunksInput: IndexGroundingChunksInput;
  IndexIntegrationDocumentsInput: IndexIntegrationDocumentsInput;
  IndexIntegrationInput: IndexIntegrationInput;
  IndexProjectsInput: IndexProjectsInput;
  IndexProjectsInputFilter: IndexProjectsInputFilter;
  IndexQueryInput: IndexQueryInput;
  IndexQueryInputFilter: IndexQueryInputFilter;
  IndexQueryMessagesFilter: IndexQueryMessagesFilter;
  IndexQueryMessagesInput: IndexQueryMessagesInput;
  IndexSourceDocumentsInput: IndexSourceDocumentsInput;
  IndexThemesInput: IndexThemesInput;
  IndexUserPreferencesInput: IndexUserPreferencesInput;
  IndexUserPreferencesInputFilter: IndexUserPreferencesInputFilter;
  IndexUsersInput: IndexUsersInput;
  IndexUsersInputFilter: IndexUsersInputFilter;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Integration: ResolverTypeWrapper<IntegrationModel>;
  IntegrationDocument: ResolverTypeWrapper<IntegrationDocument>;
  IntegrationDocumentsPage: ResolverTypeWrapper<IntegrationDocumentsPage>;
  IntegrationDocumentsPagePathSegment: ResolverTypeWrapper<IntegrationDocumentsPagePathSegment>;
  IntegrationDocumentsPagePathSegmentInput: IntegrationDocumentsPagePathSegmentInput;
  IntegrationPage: ResolverTypeWrapper<Omit<IntegrationPage, 'items'> & { items: Array<ResolversTypes['Integration']> }>;
  IntegrationSelectionResolution: ResolverTypeWrapper<IntegrationSelectionResolution>;
  IntegrationState: IntegrationState;
  IntegrationType: IntegrationType;
  Invoice: ResolverTypeWrapper<InvoiceModel>;
  InvoicePage: ResolverTypeWrapper<Omit<InvoicePage, 'items'> & { items: Array<ResolversTypes['Invoice']> }>;
  InvoiceStatus: InvoiceStatus;
  InvoiceStripeDetails: ResolverTypeWrapper<InvoiceStripeDetails>;
  ListInvoicesInput: ListInvoicesInput;
  MagicLinkInput: MagicLinkInput;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Notification: ResolverTypeWrapper<NotificationModel>;
  NotificationPreference: ResolverTypeWrapper<NotificationPreferenceModel>;
  NotificationPreferenceType: NotificationPreferenceType;
  OutstandingInvoice: ResolverTypeWrapper<OutstandingInvoice>;
  PaginationCursorInput: PaginationCursorInput;
  PaginationCursorResponse: ResolverTypeWrapper<PaginationCursorResponse>;
  PaginationInput: PaginationInput;
  PaginationResponse: ResolverTypeWrapper<PaginationResponse>;
  PayInvoiceInput: PayInvoiceInput;
  PaymentMethod: ResolverTypeWrapper<PaymentMethod>;
  PaymentResult: ResolverTypeWrapper<PaymentResult>;
  PlanChangePreview: ResolverTypeWrapper<PlanChangePreview>;
  Preference: ResolverTypeWrapper<PreferenceModel>;
  PreferenceGroup: PreferenceGroup;
  PreferenceName: PreferenceName;
  Project: ResolverTypeWrapper<ProjectModel>;
  ProjectDomain: ResolverTypeWrapper<DomainModel>;
  ProjectPage: ResolverTypeWrapper<Omit<ProjectPage, 'items'> & { items: Array<ResolversTypes['Project']> }>;
  ProjectQuery: ResolverTypeWrapper<QueryModel>;
  ProjectQuestion: ResolverTypeWrapper<ProjectQuestionModel>;
  ProjectRateLimit: ResolverTypeWrapper<ProjectRateLimitModel>;
  ProjectRule: ResolverTypeWrapper<ProjectRuleModel>;
  ProjectRuleType: ProjectRuleType;
  ProjectState: ProjectState;
  ProjectTheme: ResolverTypeWrapper<ThemeModel>;
  QuantitativeQueryMessageFeedback: QuantitativeQueryMessageFeedback;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  QueryMessage: ResolverTypeWrapper<QueryMessageResolverTypeModel>;
  QueryMessageCitation: ResolverTypeWrapper<QueryMessageCitation>;
  QueryMessageFeedback: ResolverTypeWrapper<QueryMessageFeedback>;
  QueryMessageGroundingChunk: ResolverTypeWrapper<SourceDocumentModel>;
  QueryMessageGroundingChunkFile: ResolverTypeWrapper<FileModel>;
  QueryMessageGroundingChunkSource: ResolverTypeWrapper<SourceModel>;
  QueryMessagePage: ResolverTypeWrapper<Omit<QueryMessagePage, 'items'> & { items: Array<ResolversTypes['QueryMessage']> }>;
  QueryMessagePart: ResolverTypeWrapper<QueryMessagePart>;
  QueryMessagePartExecutableCode: ResolverTypeWrapper<QueryMessagePartExecutableCode>;
  QueryMessageRole: QueryMessageRole;
  QueryMessageStatus: QueryMessageStatus;
  QueryPage: ResolverTypeWrapper<Omit<QueryPage, 'items'> & { items: Array<ResolversTypes['ProjectQuery']> }>;
  ReadQueryMessageInput: ReadQueryMessageInput;
  ReadSourceDocumentsFilter: ReadSourceDocumentsFilter;
  ReadSourceInput: ReadSourceInput;
  RegisterInput: RegisterInput;
  RegisterPayload: ResolverTypeWrapper<RegisterPayload>;
  RemovePaymentMethodInput: RemovePaymentMethodInput;
  RequestLoginMagicLinkInput: RequestLoginMagicLinkInput;
  RequestMagicLinkInput: RequestMagicLinkInput;
  ResendInviteInput: ResendInviteInput;
  ResolveIntegrationSelectionInput: ResolveIntegrationSelectionInput;
  SavePaymentMethodInput: SavePaymentMethodInput;
  SendDomainVerificationEmailInput: SendDomainVerificationEmailInput;
  SessionRateLimit: ResolverTypeWrapper<SessionRateLimit>;
  SessionToken: ResolverTypeWrapper<SessionToken>;
  Source: ResolverTypeWrapper<SourceModel>;
  SourceDocument: ResolverTypeWrapper<SourceDocumentModel>;
  SourceDocumentPage: ResolverTypeWrapper<Omit<SourceDocumentPage, 'items'> & { items: Array<ResolversTypes['SourceDocument']> }>;
  SourceType: SourceType;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  StripeIntent: ResolverTypeWrapper<StripeIntent>;
  SubscriptionAction: SubscriptionAction;
  SubscriptionStatus: SubscriptionStatus;
  SubscriptionType: SubscriptionType;
  Theme: ResolverTypeWrapper<ThemeModel>;
  ThemePage: ResolverTypeWrapper<Omit<ThemePage, 'items'> & { items: Array<ResolversTypes['Theme']> }>;
  ThemeType: ThemeType;
  Token: ResolverTypeWrapper<Token>;
  TokenBillingType: TokenBillingType;
  UpdateBillingDetailsResult: ResolverTypeWrapper<Omit<UpdateBillingDetailsResult, 'company'> & { company: ResolversTypes['UserCompany'] }>;
  UpdateCompanyInput: UpdateCompanyInput;
  UpdateMeInput: UpdateMeInput;
  UpdateNotificationInput: UpdateNotificationInput;
  UpdateNotificationPreferenceInput: UpdateNotificationPreferenceInput;
  UpdateProjectInput: UpdateProjectInput;
  UpdateProjectQuestionInput: UpdateProjectQuestionInput;
  UpdateProjectRuleInput: UpdateProjectRuleInput;
  UpdateQueryInput: UpdateQueryInput;
  UpdateQueryMessageInput: UpdateQueryMessageInput;
  UpdateRateLimit: UpdateRateLimit;
  UpdateSourceDocumentsDocumentInput: UpdateSourceDocumentsDocumentInput;
  UpdateSourceDocumentsInput: UpdateSourceDocumentsInput;
  UpdateSourceInput: UpdateSourceInput;
  UpdateThemeInput: UpdateThemeInput;
  UpdateUserInput: UpdateUserInput;
  UpdateUserPreferenceInput: UpdateUserPreferenceInput;
  UploadInstructions: ResolverTypeWrapper<UploadInstructions>;
  UsageBalance: ResolverTypeWrapper<UsageBalance>;
  UsageSummary: ResolverTypeWrapper<UsageSummary>;
  UsageSummaryMetric: ResolverTypeWrapper<UsageSummaryMetric>;
  User: ResolverTypeWrapper<UserModel>;
  UserCompany: ResolverTypeWrapper<AuthenticatedUserCompanyWithSubscriptionModel>;
  UserCompanyLimitation: UserCompanyLimitation;
  UserCompanySubscription: ResolverTypeWrapper<CompanySubscriptionModel>;
  UserPreference: ResolverTypeWrapper<UserPreferenceModel>;
  VerifyLoginMagicLinkInput: VerifyLoginMagicLinkInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AcceptInvitationInput: AcceptInvitationInput;
  AuthorisationCodeInput: AuthorisationCodeInput;
  AuthorisePayload: AuthorisePayload;
  BillingDetailsInput: BillingDetailsInput;
  BillingUsage: BillingUsage;
  Boolean: Scalars['Boolean']['output'];
  CompanyUser: CompanyUserModel;
  CompanyUserInvitation: TokenModel;
  CompanyUserPage: Omit<CompanyUserPage, 'items'> & { items: Array<ResolversParentTypes['CompanyUser']> };
  CompanyUserUser: UserModel;
  ConfirmEmailInput: ConfirmEmailInput;
  CreateDomainInput: CreateDomainInput;
  CreateFile: CreateFile;
  CreateFileInput: CreateFileInput;
  CreateFileInputFiles: CreateFileInputFiles;
  CreateIntegrationInput: CreateIntegrationInput;
  CreateInvitationForUserInput: CreateInvitationForUserInput;
  CreateNotificationPreferenceInput: CreateNotificationPreferenceInput;
  CreateProjectInput: CreateProjectInput;
  CreateQueryInput: CreateQueryInput;
  CreateQueryMessageFileInput: CreateQueryMessageFileInput;
  CreateQueryMessageInput: CreateQueryMessageInput;
  CreateQueryMessageResponse: Omit<CreateQueryMessageResponse, 'model' | 'user'> & { model: ResolversParentTypes['QueryMessage'], user: ResolversParentTypes['QueryMessage'] };
  CreateQueryResponse: Omit<CreateQueryResponse, 'model' | 'query' | 'user'> & { model: ResolversParentTypes['QueryMessage'], query: ResolversParentTypes['ProjectQuery'], user: ResolversParentTypes['QueryMessage'] };
  CreateSessionTokenInput: CreateSessionTokenInput;
  CreateSubscriptionIntentInput: CreateSubscriptionIntentInput;
  CreateThemeInput: CreateThemeInput;
  DateTimeISO: Scalars['DateTimeISO']['output'];
  DateWithCount: DateWithCount;
  DeleteDomainInput: DeleteDomainInput;
  DeleteNotificationPreferenceInput: DeleteNotificationPreferenceInput;
  DeleteUserInput: DeleteUserInput;
  DimensionInput: DimensionInput;
  Domain: DomainModel;
  DomainPage: Omit<DomainPage, 'items'> & { items: Array<ResolversParentTypes['Domain']> };
  DomainVerificationRecord: DomainVerificationRecord;
  File: FileModel;
  Float: Scalars['Float']['output'];
  IndexDomainsFilterInput: IndexDomainsFilterInput;
  IndexDomainsInput: IndexDomainsInput;
  IndexGroundingChunksInput: IndexGroundingChunksInput;
  IndexIntegrationDocumentsInput: IndexIntegrationDocumentsInput;
  IndexIntegrationInput: IndexIntegrationInput;
  IndexProjectsInput: IndexProjectsInput;
  IndexProjectsInputFilter: IndexProjectsInputFilter;
  IndexQueryInput: IndexQueryInput;
  IndexQueryInputFilter: IndexQueryInputFilter;
  IndexQueryMessagesFilter: IndexQueryMessagesFilter;
  IndexQueryMessagesInput: IndexQueryMessagesInput;
  IndexSourceDocumentsInput: IndexSourceDocumentsInput;
  IndexThemesInput: IndexThemesInput;
  IndexUserPreferencesInput: IndexUserPreferencesInput;
  IndexUserPreferencesInputFilter: IndexUserPreferencesInputFilter;
  IndexUsersInput: IndexUsersInput;
  IndexUsersInputFilter: IndexUsersInputFilter;
  Int: Scalars['Int']['output'];
  Integration: IntegrationModel;
  IntegrationDocument: IntegrationDocument;
  IntegrationDocumentsPage: IntegrationDocumentsPage;
  IntegrationDocumentsPagePathSegment: IntegrationDocumentsPagePathSegment;
  IntegrationDocumentsPagePathSegmentInput: IntegrationDocumentsPagePathSegmentInput;
  IntegrationPage: Omit<IntegrationPage, 'items'> & { items: Array<ResolversParentTypes['Integration']> };
  IntegrationSelectionResolution: IntegrationSelectionResolution;
  Invoice: InvoiceModel;
  InvoicePage: Omit<InvoicePage, 'items'> & { items: Array<ResolversParentTypes['Invoice']> };
  InvoiceStripeDetails: InvoiceStripeDetails;
  ListInvoicesInput: ListInvoicesInput;
  MagicLinkInput: MagicLinkInput;
  Mutation: Record<PropertyKey, never>;
  Notification: NotificationModel;
  NotificationPreference: NotificationPreferenceModel;
  OutstandingInvoice: OutstandingInvoice;
  PaginationCursorInput: PaginationCursorInput;
  PaginationCursorResponse: PaginationCursorResponse;
  PaginationInput: PaginationInput;
  PaginationResponse: PaginationResponse;
  PayInvoiceInput: PayInvoiceInput;
  PaymentMethod: PaymentMethod;
  PaymentResult: PaymentResult;
  PlanChangePreview: PlanChangePreview;
  Preference: PreferenceModel;
  Project: ProjectModel;
  ProjectDomain: DomainModel;
  ProjectPage: Omit<ProjectPage, 'items'> & { items: Array<ResolversParentTypes['Project']> };
  ProjectQuery: QueryModel;
  ProjectQuestion: ProjectQuestionModel;
  ProjectRateLimit: ProjectRateLimitModel;
  ProjectRule: ProjectRuleModel;
  ProjectTheme: ThemeModel;
  Query: Record<PropertyKey, never>;
  QueryMessage: QueryMessageResolverTypeModel;
  QueryMessageCitation: QueryMessageCitation;
  QueryMessageFeedback: QueryMessageFeedback;
  QueryMessageGroundingChunk: SourceDocumentModel;
  QueryMessageGroundingChunkFile: FileModel;
  QueryMessageGroundingChunkSource: SourceModel;
  QueryMessagePage: Omit<QueryMessagePage, 'items'> & { items: Array<ResolversParentTypes['QueryMessage']> };
  QueryMessagePart: QueryMessagePart;
  QueryMessagePartExecutableCode: QueryMessagePartExecutableCode;
  QueryPage: Omit<QueryPage, 'items'> & { items: Array<ResolversParentTypes['ProjectQuery']> };
  ReadQueryMessageInput: ReadQueryMessageInput;
  ReadSourceDocumentsFilter: ReadSourceDocumentsFilter;
  ReadSourceInput: ReadSourceInput;
  RegisterInput: RegisterInput;
  RegisterPayload: RegisterPayload;
  RemovePaymentMethodInput: RemovePaymentMethodInput;
  RequestLoginMagicLinkInput: RequestLoginMagicLinkInput;
  RequestMagicLinkInput: RequestMagicLinkInput;
  ResendInviteInput: ResendInviteInput;
  ResolveIntegrationSelectionInput: ResolveIntegrationSelectionInput;
  SavePaymentMethodInput: SavePaymentMethodInput;
  SendDomainVerificationEmailInput: SendDomainVerificationEmailInput;
  SessionRateLimit: SessionRateLimit;
  SessionToken: SessionToken;
  Source: SourceModel;
  SourceDocument: SourceDocumentModel;
  SourceDocumentPage: Omit<SourceDocumentPage, 'items'> & { items: Array<ResolversParentTypes['SourceDocument']> };
  String: Scalars['String']['output'];
  StripeIntent: StripeIntent;
  Theme: ThemeModel;
  ThemePage: Omit<ThemePage, 'items'> & { items: Array<ResolversParentTypes['Theme']> };
  Token: Token;
  UpdateBillingDetailsResult: Omit<UpdateBillingDetailsResult, 'company'> & { company: ResolversParentTypes['UserCompany'] };
  UpdateCompanyInput: UpdateCompanyInput;
  UpdateMeInput: UpdateMeInput;
  UpdateNotificationInput: UpdateNotificationInput;
  UpdateNotificationPreferenceInput: UpdateNotificationPreferenceInput;
  UpdateProjectInput: UpdateProjectInput;
  UpdateProjectQuestionInput: UpdateProjectQuestionInput;
  UpdateProjectRuleInput: UpdateProjectRuleInput;
  UpdateQueryInput: UpdateQueryInput;
  UpdateQueryMessageInput: UpdateQueryMessageInput;
  UpdateRateLimit: UpdateRateLimit;
  UpdateSourceDocumentsDocumentInput: UpdateSourceDocumentsDocumentInput;
  UpdateSourceDocumentsInput: UpdateSourceDocumentsInput;
  UpdateSourceInput: UpdateSourceInput;
  UpdateThemeInput: UpdateThemeInput;
  UpdateUserInput: UpdateUserInput;
  UpdateUserPreferenceInput: UpdateUserPreferenceInput;
  UploadInstructions: UploadInstructions;
  UsageBalance: UsageBalance;
  UsageSummary: UsageSummary;
  UsageSummaryMetric: UsageSummaryMetric;
  User: UserModel;
  UserCompany: AuthenticatedUserCompanyWithSubscriptionModel;
  UserCompanySubscription: CompanySubscriptionModel;
  UserPreference: UserPreferenceModel;
  VerifyLoginMagicLinkInput: VerifyLoginMagicLinkInput;
};

export type AuthorisePayloadResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['AuthorisePayload'] = ResolversParentTypes['AuthorisePayload']> = {
  accessToken: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  registeredCompanyUuid: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type BillingUsageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['BillingUsage'] = ResolversParentTypes['BillingUsage']> = {
  pages: Resolver<ResolversTypes['UsageBalance'], ParentType, ContextType>;
  queries: Resolver<ResolversTypes['UsageBalance'], ParentType, ContextType>;
};

export type CompanyUserResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['CompanyUser'] = ResolversParentTypes['CompanyUser']> = {
  companyUuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  deletedAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  invitation: Resolver<Maybe<ResolversTypes['CompanyUserInvitation']>, ParentType, ContextType>;
  role: Resolver<ResolversTypes['CompanyUserRole'], ParentType, ContextType>;
  user: Resolver<ResolversTypes['CompanyUserUser'], ParentType, ContextType>;
  userUuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CompanyUserInvitationResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['CompanyUserInvitation'] = ResolversParentTypes['CompanyUserInvitation']> = {
  expiresAt: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CompanyUserPageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['CompanyUserPage'] = ResolversParentTypes['CompanyUserPage']> = {
  items: Resolver<Array<ResolversTypes['CompanyUser']>, ParentType, ContextType>;
  pagination: Resolver<ResolversTypes['PaginationResponse'], ParentType, ContextType>;
};

export type CompanyUserRoleResolvers = EnumResolverSignature<{ accountOwner: any, admin: any, member: any }, ResolversTypes['CompanyUserRole']>;

export type CompanyUserStateResolvers = EnumResolverSignature<{ deleted: any, expired: any, invited: any, joined: any }, ResolversTypes['CompanyUserState']>;

export type CompanyUserUserResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['CompanyUserUser'] = ResolversParentTypes['CompanyUserUser']> = {
  email: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CreateFileResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['CreateFile'] = ResolversParentTypes['CreateFile']> = {
  src: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadInstructions: Resolver<ResolversTypes['UploadInstructions'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CreateQueryMessageResponseResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['CreateQueryMessageResponse'] = ResolversParentTypes['CreateQueryMessageResponse']> = {
  model: Resolver<ResolversTypes['QueryMessage'], ParentType, ContextType>;
  user: Resolver<ResolversTypes['QueryMessage'], ParentType, ContextType>;
};

export type CreateQueryResponseResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['CreateQueryResponse'] = ResolversParentTypes['CreateQueryResponse']> = {
  model: Resolver<ResolversTypes['QueryMessage'], ParentType, ContextType>;
  query: Resolver<ResolversTypes['ProjectQuery'], ParentType, ContextType>;
  user: Resolver<ResolversTypes['QueryMessage'], ParentType, ContextType>;
};

export type DateGranularityResolvers = EnumResolverSignature<{ day: any, month: any, week: any }, ResolversTypes['DateGranularity']>;

export interface DateTimeIsoScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTimeISO'], any> {
  name: 'DateTimeISO';
}

export type DateWithCountResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['DateWithCount'] = ResolversParentTypes['DateWithCount']> = {
  count: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  date: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
};

export type DomainResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Domain'] = ResolversParentTypes['Domain']> = {
  cloudflareStatus: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  projectUuid: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verificationRecords: Resolver<Array<ResolversTypes['DomainVerificationRecord']>, ParentType, ContextType>;
};

export type DomainPageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['DomainPage'] = ResolversParentTypes['DomainPage']> = {
  items: Resolver<Array<ResolversTypes['Domain']>, ParentType, ContextType>;
  pagination: Resolver<ResolversTypes['PaginationResponse'], ParentType, ContextType>;
};

export type DomainVerificationRecordResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['DomainVerificationRecord'] = ResolversParentTypes['DomainVerificationRecord']> = {
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purpose: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FailedReasonResolvers = EnumResolverSignature<{ emptyContent: any, extraction: any, invalidIntegrationDoucment: any }, ResolversTypes['FailedReason']>;

export type FileResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['File'] = ResolversParentTypes['File']> = {
  createdAt: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  downloadSrc: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  key: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  keyPrefix: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mimeType: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  src: Resolver<ResolversTypes['String'], ParentType, ContextType, FileSrcArgs>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IntegrationResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Integration'] = ResolversParentTypes['Integration']> = {
  state: Resolver<ResolversTypes['IntegrationState'], ParentType, ContextType>;
  type: Resolver<ResolversTypes['IntegrationType'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IntegrationDocumentResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['IntegrationDocument'] = ResolversParentTypes['IntegrationDocument']> = {
  hasChildren: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mimeType: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pathSegments: Resolver<Array<ResolversTypes['IntegrationDocumentsPagePathSegment']>, ParentType, ContextType>;
  relevance: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  type: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type IntegrationDocumentsPageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['IntegrationDocumentsPage'] = ResolversParentTypes['IntegrationDocumentsPage']> = {
  items: Resolver<Array<ResolversTypes['IntegrationDocument']>, ParentType, ContextType>;
  nextPageToken: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pathSegments: Resolver<Array<ResolversTypes['IntegrationDocumentsPagePathSegment']>, ParentType, ContextType>;
  totalPages: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type IntegrationDocumentsPagePathSegmentResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['IntegrationDocumentsPagePathSegment'] = ResolversParentTypes['IntegrationDocumentsPagePathSegment']> = {
  id: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type IntegrationPageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['IntegrationPage'] = ResolversParentTypes['IntegrationPage']> = {
  items: Resolver<Array<ResolversTypes['Integration']>, ParentType, ContextType>;
  pagination: Resolver<ResolversTypes['PaginationResponse'], ParentType, ContextType>;
};

export type IntegrationSelectionResolutionResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['IntegrationSelectionResolution'] = ResolversParentTypes['IntegrationSelectionResolution']> = {
  count: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type IntegrationStateResolvers = EnumResolverSignature<{ authorised: any, declined: any, expired: any, new: any }, ResolversTypes['IntegrationState']>;

export type IntegrationTypeResolvers = EnumResolverSignature<{ dropbox: any, googleDrive: any, notion: any }, ResolversTypes['IntegrationType']>;

export type InvoiceResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Invoice'] = ResolversParentTypes['Invoice']> = {
  createdAt: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  currency: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paidAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  status: Resolver<ResolversTypes['InvoiceStatus'], ParentType, ContextType>;
  stripeDetails: Resolver<Maybe<ResolversTypes['InvoiceStripeDetails']>, ParentType, ContextType>;
  subscriptionType: Resolver<Maybe<ResolversTypes['SubscriptionType']>, ParentType, ContextType>;
  subtotal: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  tax: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  total: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type InvoicePageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['InvoicePage'] = ResolversParentTypes['InvoicePage']> = {
  items: Resolver<Array<ResolversTypes['Invoice']>, ParentType, ContextType>;
  pagination: Resolver<ResolversTypes['PaginationResponse'], ParentType, ContextType>;
};

export type InvoiceStatusResolvers = EnumResolverSignature<{ draft: any, open: any, paid: any, uncollectible: any, void: any }, ResolversTypes['InvoiceStatus']>;

export type InvoiceStripeDetailsResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['InvoiceStripeDetails'] = ResolversParentTypes['InvoiceStripeDetails']> = {
  dueDate: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  hostedInvoiceUrl: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  invoicePdfUrl: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  number: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentMethodBrand: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentMethodLast4: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type MutationResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptInvitation: Resolver<ResolversTypes['Token'], ParentType, ContextType, RequireFields<MutationAcceptInvitationArgs, 'input'>>;
  authoriseWithAuthorisationCode: Resolver<ResolversTypes['AuthorisePayload'], ParentType, ContextType, RequireFields<MutationAuthoriseWithAuthorisationCodeArgs, 'input'>>;
  confirmEmail: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationConfirmEmailArgs, 'input'>>;
  createDomain: Resolver<ResolversTypes['Domain'], ParentType, ContextType, RequireFields<MutationCreateDomainArgs, 'input'>>;
  createFile: Resolver<Array<ResolversTypes['CreateFile']>, ParentType, ContextType, RequireFields<MutationCreateFileArgs, 'input'>>;
  createIntegration: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationCreateIntegrationArgs, 'input'>>;
  createInvitationForUser: Resolver<ResolversTypes['CompanyUser'], ParentType, ContextType, RequireFields<MutationCreateInvitationForUserArgs, 'input'>>;
  createNotificationPreference: Resolver<ResolversTypes['NotificationPreference'], ParentType, ContextType, RequireFields<MutationCreateNotificationPreferenceArgs, 'input'>>;
  createProject: Resolver<ResolversTypes['Project'], ParentType, ContextType, RequireFields<MutationCreateProjectArgs, 'input'>>;
  createQuery: Resolver<ResolversTypes['CreateQueryResponse'], ParentType, ContextType, RequireFields<MutationCreateQueryArgs, 'input'>>;
  createQueryMessage: Resolver<ResolversTypes['CreateQueryMessageResponse'], ParentType, ContextType, RequireFields<MutationCreateQueryMessageArgs, 'input'>>;
  createSessionToken: Resolver<ResolversTypes['SessionToken'], ParentType, ContextType, RequireFields<MutationCreateSessionTokenArgs, 'input'>>;
  createSetupIntent: Resolver<ResolversTypes['StripeIntent'], ParentType, ContextType>;
  createSubscriptionIntent: Resolver<ResolversTypes['PaymentResult'], ParentType, ContextType, RequireFields<MutationCreateSubscriptionIntentArgs, 'input'>>;
  createTheme: Resolver<ResolversTypes['Theme'], ParentType, ContextType, RequireFields<MutationCreateThemeArgs, 'input'>>;
  deleteCompany: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deleteDomain: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteDomainArgs, 'input'>>;
  deleteFile: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteFileArgs, 'uuid'>>;
  deleteMe: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  deleteNotificationPreference: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteNotificationPreferenceArgs, 'input'>>;
  deleteTheme: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteThemeArgs, 'uuid'>>;
  deleteUser: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'input'>>;
  generateProjectQuestions: Resolver<ResolversTypes['Project'], ParentType, ContextType, RequireFields<MutationGenerateProjectQuestionsArgs, 'projectUuid'>>;
  payInvoice: Resolver<ResolversTypes['PaymentResult'], ParentType, ContextType, RequireFields<MutationPayInvoiceArgs, 'input'>>;
  register: Resolver<ResolversTypes['RegisterPayload'], ParentType, ContextType, RequireFields<MutationRegisterArgs, 'input'>>;
  removePaymentMethod: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRemovePaymentMethodArgs, 'input'>>;
  requestLoginMagicLink: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRequestLoginMagicLinkArgs, 'input'>>;
  requestMagicLink: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationRequestMagicLinkArgs, 'input'>>;
  resendInvite: Resolver<ResolversTypes['CompanyUser'], ParentType, ContextType, RequireFields<MutationResendInviteArgs, 'input'>>;
  resendVerificationEmail: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  resolveIntegrationSelection: Resolver<ResolversTypes['IntegrationSelectionResolution'], ParentType, ContextType, RequireFields<MutationResolveIntegrationSelectionArgs, 'input'>>;
  savePaymentMethod: Resolver<ResolversTypes['PaymentMethod'], ParentType, ContextType, RequireFields<MutationSavePaymentMethodArgs, 'input'>>;
  sendDomainVerificationEmail: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSendDomainVerificationEmailArgs, 'input'>>;
  updateBillingDetails: Resolver<ResolversTypes['UpdateBillingDetailsResult'], ParentType, ContextType, RequireFields<MutationUpdateBillingDetailsArgs, 'input'>>;
  updateCompany: Resolver<ResolversTypes['UserCompany'], ParentType, ContextType, RequireFields<MutationUpdateCompanyArgs, 'input'>>;
  updateMe: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateMeArgs, 'input'>>;
  updateNotification: Resolver<ResolversTypes['Notification'], ParentType, ContextType, RequireFields<MutationUpdateNotificationArgs, 'input'>>;
  updateNotificationPreference: Resolver<ResolversTypes['NotificationPreference'], ParentType, ContextType, RequireFields<MutationUpdateNotificationPreferenceArgs, 'input'>>;
  updateProject: Resolver<ResolversTypes['Project'], ParentType, ContextType, RequireFields<MutationUpdateProjectArgs, 'input'>>;
  updateQuery: Resolver<ResolversTypes['ProjectQuery'], ParentType, ContextType, RequireFields<MutationUpdateQueryArgs, 'input'>>;
  updateQueryMessage: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateQueryMessageArgs, 'input'>>;
  updateRateLimit: Resolver<ResolversTypes['ProjectRateLimit'], ParentType, ContextType, RequireFields<MutationUpdateRateLimitArgs, 'input'>>;
  updateSource: Resolver<ResolversTypes['Source'], ParentType, ContextType, RequireFields<MutationUpdateSourceArgs, 'input'>>;
  updateSourceDocuments: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateSourceDocumentsArgs, 'input'>>;
  updateSubscription: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationUpdateSubscriptionArgs, 'action'>>;
  updateTheme: Resolver<ResolversTypes['Theme'], ParentType, ContextType, RequireFields<MutationUpdateThemeArgs, 'input'>>;
  updateUser: Resolver<ResolversTypes['CompanyUser'], ParentType, ContextType, RequireFields<MutationUpdateUserArgs, 'input'>>;
  updateUserPreference: Resolver<ResolversTypes['UserPreference'], ParentType, ContextType, RequireFields<MutationUpdateUserPreferenceArgs, 'input'>>;
  verifyLoginMagicLink: Resolver<ResolversTypes['Token'], ParentType, ContextType, RequireFields<MutationVerifyLoginMagicLinkArgs, 'input'>>;
};

export type NotificationResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']> = {
  createdAt: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  description: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isDismissed: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isViewed: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  path: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type NotificationPreferenceResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['NotificationPreference'] = ResolversParentTypes['NotificationPreference']> = {
  isEmail: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isWeb: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notificationType: Resolver<ResolversTypes['NotificationPreferenceType'], ParentType, ContextType>;
  notificationValue: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type NotificationPreferenceTypeResolvers = EnumResolverSignature<{ creditConsumption: any, projectReady: any }, ResolversTypes['NotificationPreferenceType']>;

export type OutstandingInvoiceResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['OutstandingInvoice'] = ResolversParentTypes['OutstandingInvoice']> = {
  subscriptionUuid: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PaginationCursorResponseResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['PaginationCursorResponse'] = ResolversParentTypes['PaginationCursorResponse']> = {
  nextPageToken: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PaginationResponseResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['PaginationResponse'] = ResolversParentTypes['PaginationResponse']> = {
  currentPage: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  from: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lastPage: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  perPage: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  to: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type PaymentMethodResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['PaymentMethod'] = ResolversParentTypes['PaymentMethod']> = {
  brand: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expMonth: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  expYear: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  last4: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  useForMonthlyPlan: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PaymentResultResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['PaymentResult'] = ResolversParentTypes['PaymentResult']> = {
  clientSecret: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  succeeded: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type PlanChangePreviewResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['PlanChangePreview'] = ResolversParentTypes['PlanChangePreview']> = {
  charge: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  discount: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type PreferenceResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Preference'] = ResolversParentTypes['Preference']> = {
  displayName: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  group: Resolver<ResolversTypes['PreferenceGroup'], ParentType, ContextType>;
  name: Resolver<ResolversTypes['PreferenceName'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PreferenceGroupResolvers = EnumResolverSignature<{ hints: any, legal: any }, ResolversTypes['PreferenceGroup']>;

export type PreferenceNameResolvers = EnumResolverSignature<{ configureSources: any, terms: any }, ResolversTypes['PreferenceName']>;

export type ProjectResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Project'] = ResolversParentTypes['Project']> = {
  createdAt: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  dailyQueryCount: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  domainPrefix: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  domains: Resolver<Array<ResolversTypes['ProjectDomain']>, ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  processedAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  processedPc: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  questions: Resolver<Array<ResolversTypes['ProjectQuestion']>, ParentType, ContextType>;
  rules: Resolver<Array<ResolversTypes['ProjectRule']>, ParentType, ContextType>;
  sourceCount: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  state: Resolver<ResolversTypes['ProjectState'], ParentType, ContextType>;
  subtitle: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  theme: Resolver<Maybe<ResolversTypes['ProjectTheme']>, ParentType, ContextType>;
  title: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProjectDomainResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['ProjectDomain'] = ResolversParentTypes['ProjectDomain']> = {
  url: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProjectPageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['ProjectPage'] = ResolversParentTypes['ProjectPage']> = {
  items: Resolver<Array<ResolversTypes['Project']>, ParentType, ContextType>;
  pagination: Resolver<ResolversTypes['PaginationResponse'], ParentType, ContextType>;
};

export type ProjectQueryResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['ProjectQuery'] = ResolversParentTypes['ProjectQuery']> = {
  isBookmarked: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rateLimit: Resolver<ResolversTypes['SessionRateLimit'], ParentType, ContextType>;
  title: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProjectQuestionResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['ProjectQuestion'] = ResolversParentTypes['ProjectQuestion']> = {
  question: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProjectRateLimitResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['ProjectRateLimit'] = ResolversParentTypes['ProjectRateLimit']> = {
  queriesPerUserPerHour: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  queryMultiplier: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProjectRuleResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['ProjectRule'] = ResolversParentTypes['ProjectRule']> = {
  type: Resolver<ResolversTypes['ProjectRuleType'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ProjectRuleTypeResolvers = EnumResolverSignature<{ domain: any, email: any, visibility: any }, ResolversTypes['ProjectRuleType']>;

export type ProjectStateResolvers = EnumResolverSignature<{ archived: any, draft: any, published: any, publishing: any }, ResolversTypes['ProjectState']>;

export type ProjectThemeResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['ProjectTheme'] = ResolversParentTypes['ProjectTheme']> = {
  brandColour: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logoSrc: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subtitle: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  themeType: Resolver<ResolversTypes['ThemeType'], ParentType, ContextType>;
  title: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type QuantitativeQueryMessageFeedbackResolvers = EnumResolverSignature<{ correct: any, incorrect: any }, ResolversTypes['QuantitativeQueryMessageFeedback']>;

export type QueryResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  countQueries: Resolver<Array<ResolversTypes['DateWithCount']>, ParentType, ContextType, RequireFields<QueryCountQueriesArgs, 'dates'>>;
  countUsageSummary: Resolver<ResolversTypes['UsageSummary'], ParentType, ContextType>;
  indexDomains: Resolver<ResolversTypes['DomainPage'], ParentType, ContextType, RequireFields<QueryIndexDomainsArgs, 'input'>>;
  indexGroundingChunks: Resolver<Array<ResolversTypes['QueryMessageGroundingChunk']>, ParentType, ContextType, RequireFields<QueryIndexGroundingChunksArgs, 'input'>>;
  indexIntegrationDocuments: Resolver<ResolversTypes['IntegrationDocumentsPage'], ParentType, ContextType, RequireFields<QueryIndexIntegrationDocumentsArgs, 'input'>>;
  indexIntegrations: Resolver<ResolversTypes['IntegrationPage'], ParentType, ContextType, QueryIndexIntegrationsArgs>;
  indexNotifications: Resolver<Array<ResolversTypes['Notification']>, ParentType, ContextType>;
  indexProjects: Resolver<ResolversTypes['ProjectPage'], ParentType, ContextType, RequireFields<QueryIndexProjectsArgs, 'input'>>;
  indexQueries: Resolver<ResolversTypes['QueryPage'], ParentType, ContextType, RequireFields<QueryIndexQueriesArgs, 'input'>>;
  indexQueryMessages: Resolver<ResolversTypes['QueryMessagePage'], ParentType, ContextType, RequireFields<QueryIndexQueryMessagesArgs, 'input'>>;
  indexSourceDocuments: Resolver<ResolversTypes['SourceDocumentPage'], ParentType, ContextType, RequireFields<QueryIndexSourceDocumentsArgs, 'input'>>;
  indexSources: Resolver<Array<ResolversTypes['Source']>, ParentType, ContextType, RequireFields<QueryIndexSourcesArgs, 'projectUuid'>>;
  indexThemes: Resolver<ResolversTypes['ThemePage'], ParentType, ContextType, RequireFields<QueryIndexThemesArgs, 'input'>>;
  indexUserPreferences: Resolver<Array<ResolversTypes['UserPreference']>, ParentType, ContextType, RequireFields<QueryIndexUserPreferencesArgs, 'input'>>;
  indexUsers: Resolver<ResolversTypes['CompanyUserPage'], ParentType, ContextType, RequireFields<QueryIndexUsersArgs, 'input'>>;
  listInvoices: Resolver<ResolversTypes['InvoicePage'], ParentType, ContextType, RequireFields<QueryListInvoicesArgs, 'input'>>;
  listPaymentMethods: Resolver<Array<ResolversTypes['PaymentMethod']>, ParentType, ContextType>;
  logout: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  me: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  notificationPreferences: Resolver<Array<ResolversTypes['NotificationPreference']>, ParentType, ContextType>;
  previewPlanChange: Resolver<ResolversTypes['PlanChangePreview'], ParentType, ContextType, RequireFields<QueryPreviewPlanChangeArgs, 'priceStep'>>;
  readChatQuestions: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  readDomain: Resolver<ResolversTypes['Domain'], ParentType, ContextType, RequireFields<QueryReadDomainArgs, 'uuid'>>;
  readIntegration: Resolver<Maybe<ResolversTypes['Integration']>, ParentType, ContextType, RequireFields<QueryReadIntegrationArgs, 'type'>>;
  readIntegrationAccessToken: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryReadIntegrationAccessTokenArgs, 'type'>>;
  readInvoice: Resolver<ResolversTypes['Invoice'], ParentType, ContextType, RequireFields<QueryReadInvoiceArgs, 'uuid'>>;
  readProject: Resolver<ResolversTypes['Project'], ParentType, ContextType, RequireFields<QueryReadProjectArgs, 'uuid'>>;
  readQuery: Resolver<Maybe<ResolversTypes['ProjectQuery']>, ParentType, ContextType, RequireFields<QueryReadQueryArgs, 'uuid'>>;
  readQueryMessage: Resolver<ResolversTypes['QueryMessage'], ParentType, ContextType, RequireFields<QueryReadQueryMessageArgs, 'input'>>;
  readRateLimit: Resolver<ResolversTypes['ProjectRateLimit'], ParentType, ContextType, RequireFields<QueryReadRateLimitArgs, 'projectUuid'>>;
  readSource: Resolver<ResolversTypes['Source'], ParentType, ContextType, RequireFields<QueryReadSourceArgs, 'input'>>;
  readTheme: Resolver<ResolversTypes['Theme'], ParentType, ContextType, RequireFields<QueryReadThemeArgs, 'uuid'>>;
  readUsage: Resolver<ResolversTypes['BillingUsage'], ParentType, ContextType>;
};

export type QueryMessageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessage'] = ResolversParentTypes['QueryMessage']> = {
  citations: Resolver<Array<ResolversTypes['QueryMessageCitation']>, ParentType, ContextType>;
  createdAt: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  feedback: Resolver<Maybe<ResolversTypes['QueryMessageFeedback']>, ParentType, ContextType>;
  files: Resolver<Array<ResolversTypes['File']>, ParentType, ContextType>;
  groundingChunks: Resolver<Array<ResolversTypes['QueryMessageGroundingChunk']>, ParentType, ContextType>;
  parts: Resolver<Array<ResolversTypes['QueryMessagePart']>, ParentType, ContextType>;
  retrievalToken: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role: Resolver<ResolversTypes['QueryMessageRole'], ParentType, ContextType>;
  status: Resolver<ResolversTypes['QueryMessageStatus'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type QueryMessageCitationResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessageCitation'] = ResolversParentTypes['QueryMessageCitation']> = {
  chunkId: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endIndex: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  snippet: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startIndex: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type QueryMessageFeedbackResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessageFeedback'] = ResolversParentTypes['QueryMessageFeedback']> = {
  qualitative: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quantitative: Resolver<ResolversTypes['QuantitativeQueryMessageFeedback'], ParentType, ContextType>;
};

export type QueryMessageGroundingChunkResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessageGroundingChunk'] = ResolversParentTypes['QueryMessageGroundingChunk']> = {
  description: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  favicon: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  file: Resolver<Maybe<ResolversTypes['QueryMessageGroundingChunkFile']>, ParentType, ContextType>;
  hostedIntegrationPath: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source: Resolver<ResolversTypes['QueryMessageGroundingChunkSource'], ParentType, ContextType>;
  title: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type QueryMessageGroundingChunkFileResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessageGroundingChunkFile'] = ResolversParentTypes['QueryMessageGroundingChunkFile']> = {
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type QueryMessageGroundingChunkSourceResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessageGroundingChunkSource'] = ResolversParentTypes['QueryMessageGroundingChunkSource']> = {
  type: Resolver<ResolversTypes['SourceType'], ParentType, ContextType>;
};

export type QueryMessagePageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessagePage'] = ResolversParentTypes['QueryMessagePage']> = {
  items: Resolver<Array<ResolversTypes['QueryMessage']>, ParentType, ContextType>;
  lastEvaluatedKey: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type QueryMessagePartResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessagePart'] = ResolversParentTypes['QueryMessagePart']> = {
  executableCode: Resolver<Maybe<ResolversTypes['QueryMessagePartExecutableCode']>, ParentType, ContextType>;
  text: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thought: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type QueryMessagePartExecutableCodeResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryMessagePartExecutableCode'] = ResolversParentTypes['QueryMessagePartExecutableCode']> = {
  code: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  language: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type QueryMessageRoleResolvers = EnumResolverSignature<{ model: any, user: any }, ResolversTypes['QueryMessageRole']>;

export type QueryMessageStatusResolvers = EnumResolverSignature<{ completed: any, failed: any, new: any, processing: any, stopped: any }, ResolversTypes['QueryMessageStatus']>;

export type QueryPageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['QueryPage'] = ResolversParentTypes['QueryPage']> = {
  items: Resolver<Array<ResolversTypes['ProjectQuery']>, ParentType, ContextType>;
  pagination: Resolver<ResolversTypes['PaginationResponse'], ParentType, ContextType>;
};

export type RegisterPayloadResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['RegisterPayload'] = ResolversParentTypes['RegisterPayload']> = {
  accessToken: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  companyUuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SessionRateLimitResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['SessionRateLimit'] = ResolversParentTypes['SessionRateLimit']> = {
  queriesConsumed: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  queriesPerUserPerHour: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  queriesRemaining: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  queriesUsedThisHour: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  queryMultiplier: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  resetsAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
};

export type SessionTokenResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['SessionToken'] = ResolversParentTypes['SessionToken']> = {
  accessToken: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SourceResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Source'] = ResolversParentTypes['Source']> = {
  documentCount: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type: Resolver<ResolversTypes['SourceType'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SourceDocumentResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['SourceDocument'] = ResolversParentTypes['SourceDocument']> = {
  description: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  failedAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  failedReason: Resolver<Maybe<ResolversTypes['FailedReason']>, ParentType, ContextType>;
  file: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  hostedIntegrationDocumentId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hostedIntegrationPath: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  processedAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  thumbnail: Resolver<Maybe<ResolversTypes['File']>, ParentType, ContextType>;
  title: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SourceDocumentPageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['SourceDocumentPage'] = ResolversParentTypes['SourceDocumentPage']> = {
  items: Resolver<Array<ResolversTypes['SourceDocument']>, ParentType, ContextType>;
  pagination: Resolver<ResolversTypes['PaginationResponse'], ParentType, ContextType>;
};

export type SourceTypeResolvers = EnumResolverSignature<{ dropbox: any, file: any, googleDrive: any, notion: any, url: any }, ResolversTypes['SourceType']>;

export type StripeIntentResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['StripeIntent'] = ResolversParentTypes['StripeIntent']> = {
  clientSecret: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SubscriptionActionResolvers = EnumResolverSignature<{ cancel: any, pause: any, resume: any, uncancel: any }, ResolversTypes['SubscriptionAction']>;

export type SubscriptionStatusResolvers = EnumResolverSignature<{ active: any, canceled: any, incomplete: any, incomplete_expired: any, past_due: any, paused: any, trialing: any, unpaid: any }, ResolversTypes['SubscriptionStatus']>;

export type SubscriptionTypeResolvers = EnumResolverSignature<{ enterprise: any, essentials: any }, ResolversTypes['SubscriptionType']>;

export type ThemeResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Theme'] = ResolversParentTypes['Theme']> = {
  brandColour: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt: Resolver<ResolversTypes['DateTimeISO'], ParentType, ContextType>;
  logo: Resolver<ResolversTypes['File'], ParentType, ContextType>;
  name: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projectCount: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subtitle: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  themeType: Resolver<ResolversTypes['ThemeType'], ParentType, ContextType>;
  title: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  used: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ThemePageResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['ThemePage'] = ResolversParentTypes['ThemePage']> = {
  items: Resolver<Array<ResolversTypes['Theme']>, ParentType, ContextType>;
  pagination: Resolver<ResolversTypes['PaginationResponse'], ParentType, ContextType>;
};

export type ThemeTypeResolvers = EnumResolverSignature<{ dark: any, light: any }, ResolversTypes['ThemeType']>;

export type TokenResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['Token'] = ResolversParentTypes['Token']> = {
  accessToken: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TokenBillingTypeResolvers = EnumResolverSignature<{ invoice: any, subscription: any }, ResolversTypes['TokenBillingType']>;

export type UpdateBillingDetailsResultResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['UpdateBillingDetailsResult'] = ResolversParentTypes['UpdateBillingDetailsResult']> = {
  company: Resolver<ResolversTypes['UserCompany'], ParentType, ContextType>;
  removedPaymentMethods: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type UploadInstructionsResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['UploadInstructions'] = ResolversParentTypes['UploadInstructions']> = {
  key: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  keyPrefix: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type UsageBalanceResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['UsageBalance'] = ResolversParentTypes['UsageBalance']> = {
  total: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  used: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type UsageSummaryResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['UsageSummary'] = ResolversParentTypes['UsageSummary']> = {
  pages: Resolver<ResolversTypes['UsageSummaryMetric'], ParentType, ContextType>;
  queries: Resolver<ResolversTypes['UsageSummaryMetric'], ParentType, ContextType>;
  users: Resolver<ResolversTypes['UsageSummaryMetric'], ParentType, ContextType>;
};

export type UsageSummaryMetricResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['UsageSummaryMetric'] = ResolversParentTypes['UsageSummaryMetric']> = {
  current: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  previous: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sparkline: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type UserResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  company: Resolver<ResolversTypes['UserCompany'], ParentType, ContextType>;
  email: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasPendingEmail: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  onboardingCompletedAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  pendingEmail: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role: Resolver<ResolversTypes['CompanyUserRole'], ParentType, ContextType>;
  unreadNotificationCount: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verifiedEmailAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
};

export type UserCompanyResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['UserCompany'] = ResolversParentTypes['UserCompany']> = {
  billingAddressLine1: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingAddressLine2: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCity: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingCountry: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingPostalCode: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limitations: Resolver<Array<ResolversTypes['UserCompanyLimitation']>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  outstandingInvoice: Resolver<Maybe<ResolversTypes['OutstandingInvoice']>, ParentType, ContextType>;
  subscription: Resolver<Maybe<ResolversTypes['UserCompanySubscription']>, ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vatNumber: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type UserCompanyLimitationResolvers = EnumResolverSignature<{ cannotCreateDomain: any, cannotCreateProject: any, cannotCreateQueryMessage: any, cannotCreateSourceDocument: any }, ResolversTypes['UserCompanyLimitation']>;

export type UserCompanySubscriptionResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['UserCompanySubscription'] = ResolversParentTypes['UserCompanySubscription']> = {
  expiresAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  renewsAt: Resolver<Maybe<ResolversTypes['DateTimeISO']>, ParentType, ContextType>;
  status: Resolver<ResolversTypes['SubscriptionStatus'], ParentType, ContextType>;
  subtotal: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  tokenBillingType: Resolver<ResolversTypes['TokenBillingType'], ParentType, ContextType>;
  type: Resolver<ResolversTypes['SubscriptionType'], ParentType, ContextType>;
  uuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type UserPreferenceResolvers<ContextType = InvocationContext, ParentType extends ResolversParentTypes['UserPreference'] = ResolversParentTypes['UserPreference']> = {
  preference: Resolver<ResolversTypes['Preference'], ParentType, ContextType>;
  preferenceUuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userUuid: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type Resolvers<ContextType = InvocationContext> = {
  AuthorisePayload: AuthorisePayloadResolvers<ContextType>;
  BillingUsage: BillingUsageResolvers<ContextType>;
  CompanyUser: CompanyUserResolvers<ContextType>;
  CompanyUserInvitation: CompanyUserInvitationResolvers<ContextType>;
  CompanyUserPage: CompanyUserPageResolvers<ContextType>;
  CompanyUserRole: CompanyUserRoleResolvers;
  CompanyUserState: CompanyUserStateResolvers;
  CompanyUserUser: CompanyUserUserResolvers<ContextType>;
  CreateFile: CreateFileResolvers<ContextType>;
  CreateQueryMessageResponse: CreateQueryMessageResponseResolvers<ContextType>;
  CreateQueryResponse: CreateQueryResponseResolvers<ContextType>;
  DateGranularity: DateGranularityResolvers;
  DateTimeISO: GraphQLScalarType;
  DateWithCount: DateWithCountResolvers<ContextType>;
  Domain: DomainResolvers<ContextType>;
  DomainPage: DomainPageResolvers<ContextType>;
  DomainVerificationRecord: DomainVerificationRecordResolvers<ContextType>;
  FailedReason: FailedReasonResolvers;
  File: FileResolvers<ContextType>;
  Integration: IntegrationResolvers<ContextType>;
  IntegrationDocument: IntegrationDocumentResolvers<ContextType>;
  IntegrationDocumentsPage: IntegrationDocumentsPageResolvers<ContextType>;
  IntegrationDocumentsPagePathSegment: IntegrationDocumentsPagePathSegmentResolvers<ContextType>;
  IntegrationPage: IntegrationPageResolvers<ContextType>;
  IntegrationSelectionResolution: IntegrationSelectionResolutionResolvers<ContextType>;
  IntegrationState: IntegrationStateResolvers;
  IntegrationType: IntegrationTypeResolvers;
  Invoice: InvoiceResolvers<ContextType>;
  InvoicePage: InvoicePageResolvers<ContextType>;
  InvoiceStatus: InvoiceStatusResolvers;
  InvoiceStripeDetails: InvoiceStripeDetailsResolvers<ContextType>;
  Mutation: MutationResolvers<ContextType>;
  Notification: NotificationResolvers<ContextType>;
  NotificationPreference: NotificationPreferenceResolvers<ContextType>;
  NotificationPreferenceType: NotificationPreferenceTypeResolvers;
  OutstandingInvoice: OutstandingInvoiceResolvers<ContextType>;
  PaginationCursorResponse: PaginationCursorResponseResolvers<ContextType>;
  PaginationResponse: PaginationResponseResolvers<ContextType>;
  PaymentMethod: PaymentMethodResolvers<ContextType>;
  PaymentResult: PaymentResultResolvers<ContextType>;
  PlanChangePreview: PlanChangePreviewResolvers<ContextType>;
  Preference: PreferenceResolvers<ContextType>;
  PreferenceGroup: PreferenceGroupResolvers;
  PreferenceName: PreferenceNameResolvers;
  Project: ProjectResolvers<ContextType>;
  ProjectDomain: ProjectDomainResolvers<ContextType>;
  ProjectPage: ProjectPageResolvers<ContextType>;
  ProjectQuery: ProjectQueryResolvers<ContextType>;
  ProjectQuestion: ProjectQuestionResolvers<ContextType>;
  ProjectRateLimit: ProjectRateLimitResolvers<ContextType>;
  ProjectRule: ProjectRuleResolvers<ContextType>;
  ProjectRuleType: ProjectRuleTypeResolvers;
  ProjectState: ProjectStateResolvers;
  ProjectTheme: ProjectThemeResolvers<ContextType>;
  QuantitativeQueryMessageFeedback: QuantitativeQueryMessageFeedbackResolvers;
  Query: QueryResolvers<ContextType>;
  QueryMessage: QueryMessageResolvers<ContextType>;
  QueryMessageCitation: QueryMessageCitationResolvers<ContextType>;
  QueryMessageFeedback: QueryMessageFeedbackResolvers<ContextType>;
  QueryMessageGroundingChunk: QueryMessageGroundingChunkResolvers<ContextType>;
  QueryMessageGroundingChunkFile: QueryMessageGroundingChunkFileResolvers<ContextType>;
  QueryMessageGroundingChunkSource: QueryMessageGroundingChunkSourceResolvers<ContextType>;
  QueryMessagePage: QueryMessagePageResolvers<ContextType>;
  QueryMessagePart: QueryMessagePartResolvers<ContextType>;
  QueryMessagePartExecutableCode: QueryMessagePartExecutableCodeResolvers<ContextType>;
  QueryMessageRole: QueryMessageRoleResolvers;
  QueryMessageStatus: QueryMessageStatusResolvers;
  QueryPage: QueryPageResolvers<ContextType>;
  RegisterPayload: RegisterPayloadResolvers<ContextType>;
  SessionRateLimit: SessionRateLimitResolvers<ContextType>;
  SessionToken: SessionTokenResolvers<ContextType>;
  Source: SourceResolvers<ContextType>;
  SourceDocument: SourceDocumentResolvers<ContextType>;
  SourceDocumentPage: SourceDocumentPageResolvers<ContextType>;
  SourceType: SourceTypeResolvers;
  StripeIntent: StripeIntentResolvers<ContextType>;
  SubscriptionAction: SubscriptionActionResolvers;
  SubscriptionStatus: SubscriptionStatusResolvers;
  SubscriptionType: SubscriptionTypeResolvers;
  Theme: ThemeResolvers<ContextType>;
  ThemePage: ThemePageResolvers<ContextType>;
  ThemeType: ThemeTypeResolvers;
  Token: TokenResolvers<ContextType>;
  TokenBillingType: TokenBillingTypeResolvers;
  UpdateBillingDetailsResult: UpdateBillingDetailsResultResolvers<ContextType>;
  UploadInstructions: UploadInstructionsResolvers<ContextType>;
  UsageBalance: UsageBalanceResolvers<ContextType>;
  UsageSummary: UsageSummaryResolvers<ContextType>;
  UsageSummaryMetric: UsageSummaryMetricResolvers<ContextType>;
  User: UserResolvers<ContextType>;
  UserCompany: UserCompanyResolvers<ContextType>;
  UserCompanyLimitation: UserCompanyLimitationResolvers;
  UserCompanySubscription: UserCompanySubscriptionResolvers<ContextType>;
  UserPreference: UserPreferenceResolvers<ContextType>;
};


export type CreateSessionTokenMutationVariables = Exact<{
  input: CreateSessionTokenInput;
}>;


export type CreateSessionTokenMutation = { __typename?: 'Mutation', createSessionToken: { __typename?: 'SessionToken', accessToken: string } };

export type ReadChatQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadChatQuestionsQuery = { __typename?: 'Query', readChatQuestions: Array<string> };

export type RequestMagicLinkMutationVariables = Exact<{
  input: RequestMagicLinkInput;
}>;


export type RequestMagicLinkMutation = { __typename?: 'Mutation', requestMagicLink: boolean };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', user: { __typename?: 'User', uuid: string, email: string, name: string | null, verifiedEmailAt: string | null, onboardingCompletedAt: string | null, hasPendingEmail: boolean | null, pendingEmail: string | null, role: CompanyUserRole, company: { __typename?: 'UserCompany', uuid: string, name: string | null, billingCountry: string | null, vatNumber: string | null, billingAddressLine1: string | null, billingAddressLine2: string | null, billingCity: string | null, billingPostalCode: string | null, limitations: Array<UserCompanyLimitation>, subscription: { __typename?: 'UserCompanySubscription', uuid: string, subtotal: number, type: SubscriptionType, status: SubscriptionStatus, tokenBillingType: TokenBillingType, renewsAt: string | null, expiresAt: string | null } | null, outstandingInvoice: { __typename?: 'OutstandingInvoice', uuid: string, subscriptionUuid: string | null } | null } } };

export type UserFragmentFragment = { __typename?: 'User', uuid: string, email: string, name: string | null, verifiedEmailAt: string | null, onboardingCompletedAt: string | null, hasPendingEmail: boolean | null, pendingEmail: string | null, role: CompanyUserRole, company: { __typename?: 'UserCompany', uuid: string, name: string | null, billingCountry: string | null, vatNumber: string | null, billingAddressLine1: string | null, billingAddressLine2: string | null, billingCity: string | null, billingPostalCode: string | null, limitations: Array<UserCompanyLimitation>, subscription: { __typename?: 'UserCompanySubscription', uuid: string, subtotal: number, type: SubscriptionType, status: SubscriptionStatus, tokenBillingType: TokenBillingType, renewsAt: string | null, expiresAt: string | null } | null, outstandingInvoice: { __typename?: 'OutstandingInvoice', uuid: string, subscriptionUuid: string | null } | null } };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'RegisterPayload', accessToken: string, companyUuid: string } };

export type RequestLoginMagicLinkMutationVariables = Exact<{
  input: RequestLoginMagicLinkInput;
}>;


export type RequestLoginMagicLinkMutation = { __typename?: 'Mutation', requestLoginMagicLink: boolean };

export type VerifyLoginMagicLinkMutationVariables = Exact<{
  input: VerifyLoginMagicLinkInput;
}>;


export type VerifyLoginMagicLinkMutation = { __typename?: 'Mutation', verifyLoginMagicLink: { __typename?: 'Token', accessToken: string } };

export type AuthoriseWithAuthorisationCodeMutationVariables = Exact<{
  input: AuthorisationCodeInput;
}>;


export type AuthoriseWithAuthorisationCodeMutation = { __typename?: 'Mutation', authoriseWithAuthorisationCode: { __typename?: 'AuthorisePayload', accessToken: string, registeredCompanyUuid: string | null } };

export type LogoutQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoutQuery = { __typename?: 'Query', logout: boolean };

export type ConfirmEmailMutationVariables = Exact<{
  input: ConfirmEmailInput;
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: boolean };

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail: boolean };

export type IndexSourceDocumentsForDocumentBrowserQueryVariables = Exact<{
  input: IndexSourceDocumentsInput;
}>;


export type IndexSourceDocumentsForDocumentBrowserQuery = { __typename?: 'Query', indexSourceDocuments: { __typename?: 'SourceDocumentPage', items: Array<{ __typename?: 'SourceDocument', uuid: string, hostedIntegrationDocumentId: string | null, hostedIntegrationPath: string | null }>, pagination: { __typename?: 'PaginationResponse', lastPage: number } } };

export type IndexNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IndexNotificationsQuery = { __typename?: 'Query', indexNotifications: Array<{ __typename?: 'Notification', uuid: string, title: string, description: string, path: string, isDismissed: boolean, isViewed: boolean, createdAt: string }> };

export type UpdateNotificationMutationVariables = Exact<{
  input: UpdateNotificationInput;
}>;


export type UpdateNotificationMutation = { __typename?: 'Mutation', updateNotification: { __typename?: 'Notification', uuid: string, title: string, description: string, path: string, isDismissed: boolean, isViewed: boolean, createdAt: string } };

export type CountQueriesQueryVariables = Exact<{
  dates: Array<Scalars['DateTimeISO']['input']> | Scalars['DateTimeISO']['input'];
  unique: InputMaybe<Scalars['Boolean']['input']>;
  granularity: InputMaybe<DateGranularity>;
}>;


export type CountQueriesQuery = { __typename?: 'Query', countQueries: Array<{ __typename?: 'DateWithCount', date: string, count: number }> };

export type CountUsageSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type CountUsageSummaryQuery = { __typename?: 'Query', countUsageSummary: { __typename?: 'UsageSummary', users: { __typename?: 'UsageSummaryMetric', current: number, previous: number, sparkline: Array<number> }, queries: { __typename?: 'UsageSummaryMetric', current: number, previous: number, sparkline: Array<number> }, pages: { __typename?: 'UsageSummaryMetric', current: number, previous: number, sparkline: Array<number> } } };

export type ReadProjectQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ReadProjectQuery = { __typename?: 'Query', readProject: { __typename?: 'Project', uuid: string, name: string, state: ProjectState, sourceCount: number, processedPc: number, processedAt: string | null, domainPrefix: string, createdAt: string, title: string | null, subtitle: string | null, questions: Array<{ __typename?: 'ProjectQuestion', uuid: string, question: string }>, domains: Array<{ __typename?: 'ProjectDomain', uuid: string, url: string }>, theme: { __typename?: 'ProjectTheme', uuid: string, name: string, brandColour: string, themeType: ThemeType, title: string | null, subtitle: string | null, logoSrc: string } | null } };

export type ReadProjectRulesQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ReadProjectRulesQuery = { __typename?: 'Query', readProject: { __typename?: 'Project', uuid: string, rules: Array<{ __typename?: 'ProjectRule', uuid: string, type: ProjectRuleType, value: string }> } };

export type ProjectFragment = { __typename?: 'Project', uuid: string, name: string, state: ProjectState, sourceCount: number, processedPc: number, processedAt: string | null, domainPrefix: string, createdAt: string, title: string | null, subtitle: string | null, questions: Array<{ __typename?: 'ProjectQuestion', uuid: string, question: string }>, domains: Array<{ __typename?: 'ProjectDomain', uuid: string, url: string }>, theme: { __typename?: 'ProjectTheme', uuid: string, name: string, brandColour: string, themeType: ThemeType, title: string | null, subtitle: string | null, logoSrc: string } | null };

export type IndexProjectsQueryVariables = Exact<{
  input: IndexProjectsInput;
}>;


export type IndexProjectsQuery = { __typename?: 'Query', indexProjects: { __typename?: 'ProjectPage', pagination: { __typename?: 'PaginationResponse', lastPage: number }, items: Array<{ __typename?: 'Project', uuid: string, name: string, state: ProjectState, sourceCount: number, dailyQueryCount: number, domains: Array<{ __typename?: 'ProjectDomain', uuid: string, url: string }>, theme: { __typename?: 'ProjectTheme', uuid: string, name: string } | null }> } };

export type CreateProjectMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', createProject: { __typename?: 'Project', uuid: string } };

export type CreateIntegrationMutationVariables = Exact<{
  input: CreateIntegrationInput;
}>;


export type CreateIntegrationMutation = { __typename?: 'Mutation', createIntegration: boolean | null };

export type ReadIntegrationQueryVariables = Exact<{
  type: IntegrationType;
}>;


export type ReadIntegrationQuery = { __typename?: 'Query', readIntegration: { __typename?: 'Integration', uuid: string, state: IntegrationState } | null };

export type ReadIntegrationAccessTokenQueryVariables = Exact<{
  type: IntegrationType;
}>;


export type ReadIntegrationAccessTokenQuery = { __typename?: 'Query', readIntegrationAccessToken: string | null };

export type IndexIntegrationsQueryVariables = Exact<{
  input: InputMaybe<IndexIntegrationInput>;
}>;


export type IndexIntegrationsQuery = { __typename?: 'Query', indexIntegrations: { __typename?: 'IntegrationPage', items: Array<{ __typename?: 'Integration', uuid: string, type: IntegrationType, state: IntegrationState }> } };

export type ReadSourceQueryVariables = Exact<{
  input: ReadSourceInput;
}>;


export type ReadSourceQuery = { __typename?: 'Query', readSource: { __typename?: 'Source', uuid: string, name: string | null, type: SourceType } };

export type IndexSourceDocumentsQueryVariables = Exact<{
  input: IndexSourceDocumentsInput;
  dimensionsInput: InputMaybe<DimensionInput>;
}>;


export type IndexSourceDocumentsQuery = { __typename?: 'Query', indexSourceDocuments: { __typename?: 'SourceDocumentPage', items: Array<{ __typename?: 'SourceDocument', uuid: string, title: string, description: string | null, hostedIntegrationPath: string | null, hostedIntegrationDocumentId: string | null, processedAt: string | null, failedReason: FailedReason | null, url: string | null, thumbnail: { __typename?: 'File', src: string } | null }>, pagination: { __typename?: 'PaginationResponse', lastPage: number } } };

export type IndexSourcesQueryVariables = Exact<{
  projectUuid: Scalars['String']['input'];
}>;


export type IndexSourcesQuery = { __typename?: 'Query', indexSources: Array<{ __typename?: 'Source', uuid: string, name: string | null, documentCount: number, type: SourceType }> };

export type UpdateSourceMutationVariables = Exact<{
  input: UpdateSourceInput;
}>;


export type UpdateSourceMutation = { __typename?: 'Mutation', updateSource: { __typename?: 'Source', uuid: string, name: string | null } };

export type IndexIntegrationDocumentsQueryVariables = Exact<{
  input: IndexIntegrationDocumentsInput;
}>;


export type IndexIntegrationDocumentsQuery = { __typename?: 'Query', indexIntegrationDocuments: { __typename?: 'IntegrationDocumentsPage', nextPageToken: string | null, totalPages: number | null, items: Array<{ __typename?: 'IntegrationDocument', id: string, name: string, hasChildren: boolean, type: string, relevance: string, mimeType: string, pathSegments: Array<{ __typename?: 'IntegrationDocumentsPagePathSegment', id: string, name: string, type: string | null }> }>, pathSegments: Array<{ __typename?: 'IntegrationDocumentsPagePathSegment', id: string, name: string, type: string | null }> } };

export type UpdateSourceDocumentsMutationVariables = Exact<{
  input: UpdateSourceDocumentsInput;
}>;


export type UpdateSourceDocumentsMutation = { __typename?: 'Mutation', updateSourceDocuments: boolean };

export type ResolveIntegrationSelectionMutationVariables = Exact<{
  input: ResolveIntegrationSelectionInput;
}>;


export type ResolveIntegrationSelectionMutation = { __typename?: 'Mutation', resolveIntegrationSelection: { __typename?: 'IntegrationSelectionResolution', count: number } };

export type GenerateProjectQuestionsMutationVariables = Exact<{
  projectUuid: Scalars['String']['input'];
}>;


export type GenerateProjectQuestionsMutation = { __typename?: 'Mutation', generateProjectQuestions: { __typename?: 'Project', uuid: string, name: string, state: ProjectState, sourceCount: number, processedPc: number, processedAt: string | null, domainPrefix: string, createdAt: string, title: string | null, subtitle: string | null, questions: Array<{ __typename?: 'ProjectQuestion', uuid: string, question: string }>, domains: Array<{ __typename?: 'ProjectDomain', uuid: string, url: string }>, theme: { __typename?: 'ProjectTheme', uuid: string, name: string, brandColour: string, themeType: ThemeType, title: string | null, subtitle: string | null, logoSrc: string } | null } };

export type UpdateProjectMutationVariables = Exact<{
  input: UpdateProjectInput;
}>;


export type UpdateProjectMutation = { __typename?: 'Mutation', updateProject: { __typename?: 'Project', uuid: string, name: string, state: ProjectState, sourceCount: number, processedPc: number, processedAt: string | null, domainPrefix: string, createdAt: string, title: string | null, subtitle: string | null, questions: Array<{ __typename?: 'ProjectQuestion', uuid: string, question: string }>, domains: Array<{ __typename?: 'ProjectDomain', uuid: string, url: string }>, theme: { __typename?: 'ProjectTheme', uuid: string, name: string, brandColour: string, themeType: ThemeType, title: string | null, subtitle: string | null, logoSrc: string } | null } };

export type IndexDomainsQueryVariables = Exact<{
  input: IndexDomainsInput;
}>;


export type IndexDomainsQuery = { __typename?: 'Query', indexDomains: { __typename?: 'DomainPage', items: Array<{ __typename?: 'Domain', uuid: string, url: string, projectUuid: string | null, createdAt: string, cloudflareStatus: string }>, pagination: { __typename?: 'PaginationResponse', lastPage: number } } };

export type ReadDomainQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ReadDomainQuery = { __typename?: 'Query', readDomain: { __typename?: 'Domain', uuid: string, url: string, cloudflareStatus: string, verificationRecords: Array<{ __typename?: 'DomainVerificationRecord', purpose: string, name: string, value: string }> } };

export type CreateDomainMutationVariables = Exact<{
  input: CreateDomainInput;
}>;


export type CreateDomainMutation = { __typename?: 'Mutation', createDomain: { __typename?: 'Domain', uuid: string, url: string, projectUuid: string | null, createdAt: string } };

export type DeleteDomainMutationVariables = Exact<{
  input: DeleteDomainInput;
}>;


export type DeleteDomainMutation = { __typename?: 'Mutation', deleteDomain: boolean };

export type SendDomainVerificationEmailMutationVariables = Exact<{
  input: SendDomainVerificationEmailInput;
}>;


export type SendDomainVerificationEmailMutation = { __typename?: 'Mutation', sendDomainVerificationEmail: boolean };

export type ThemeFragment = { __typename?: 'Theme', uuid: string, name: string, themeType: ThemeType, brandColour: string, title: string | null, subtitle: string | null, createdAt: string, used: boolean, projectCount: number, logo: { __typename?: 'File', uuid: string, name: string, src: string } };

export type IndexThemesQueryVariables = Exact<{
  input: IndexThemesInput;
}>;


export type IndexThemesQuery = { __typename?: 'Query', indexThemes: { __typename?: 'ThemePage', pagination: { __typename?: 'PaginationResponse', lastPage: number }, items: Array<{ __typename?: 'Theme', uuid: string, name: string, themeType: ThemeType, brandColour: string, title: string | null, subtitle: string | null, createdAt: string, used: boolean, projectCount: number, logo: { __typename?: 'File', uuid: string, name: string, src: string } }> } };

export type ReadThemeQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ReadThemeQuery = { __typename?: 'Query', readTheme: { __typename?: 'Theme', uuid: string, name: string, themeType: ThemeType, brandColour: string, title: string | null, subtitle: string | null, createdAt: string, used: boolean, projectCount: number, logo: { __typename?: 'File', uuid: string, name: string, src: string } } };

export type CreateThemeMutationVariables = Exact<{
  input: CreateThemeInput;
}>;


export type CreateThemeMutation = { __typename?: 'Mutation', createTheme: { __typename?: 'Theme', uuid: string } };

export type UpdateThemeMutationVariables = Exact<{
  input: UpdateThemeInput;
}>;


export type UpdateThemeMutation = { __typename?: 'Mutation', updateTheme: { __typename?: 'Theme', uuid: string, name: string, themeType: ThemeType, brandColour: string, title: string | null, subtitle: string | null, createdAt: string, used: boolean, projectCount: number, logo: { __typename?: 'File', uuid: string, name: string, src: string } } };

export type DeleteThemeMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteThemeMutation = { __typename?: 'Mutation', deleteTheme: boolean };

export type ReadRateLimitQueryVariables = Exact<{
  projectUuid: Scalars['String']['input'];
}>;


export type ReadRateLimitQuery = { __typename?: 'Query', readRateLimit: { __typename?: 'ProjectRateLimit', uuid: string, queryMultiplier: number, queriesPerUserPerHour: number } };

export type UpdateRateLimitMutationVariables = Exact<{
  input: UpdateRateLimit;
}>;


export type UpdateRateLimitMutation = { __typename?: 'Mutation', updateRateLimit: { __typename?: 'ProjectRateLimit', uuid: string, queryMultiplier: number, queriesPerUserPerHour: number } };

export type CompanyUserRowFragment = { __typename?: 'CompanyUser', uuid: string, userUuid: string, companyUuid: string, role: CompanyUserRole, createdAt: string | null, deletedAt: string | null, user: { __typename?: 'CompanyUserUser', uuid: string, name: string | null, email: string }, invitation: { __typename?: 'CompanyUserInvitation', uuid: string, expiresAt: string } | null };

export type IndexUsersQueryVariables = Exact<{
  input: IndexUsersInput;
}>;


export type IndexUsersQuery = { __typename?: 'Query', indexUsers: { __typename?: 'CompanyUserPage', pagination: { __typename?: 'PaginationResponse', lastPage: number }, items: Array<{ __typename?: 'CompanyUser', uuid: string, userUuid: string, companyUuid: string, role: CompanyUserRole, createdAt: string | null, deletedAt: string | null, user: { __typename?: 'CompanyUserUser', uuid: string, name: string | null, email: string }, invitation: { __typename?: 'CompanyUserInvitation', uuid: string, expiresAt: string } | null }> } };

export type CreateInvitationForUserMutationVariables = Exact<{
  input: CreateInvitationForUserInput;
}>;


export type CreateInvitationForUserMutation = { __typename?: 'Mutation', createInvitationForUser: { __typename?: 'CompanyUser', uuid: string, userUuid: string, companyUuid: string, role: CompanyUserRole, createdAt: string | null, deletedAt: string | null, user: { __typename?: 'CompanyUserUser', uuid: string, name: string | null, email: string }, invitation: { __typename?: 'CompanyUserInvitation', uuid: string, expiresAt: string } | null } };

export type UpdateCompanyUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateCompanyUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'CompanyUser', uuid: string, userUuid: string, companyUuid: string, role: CompanyUserRole, createdAt: string | null, deletedAt: string | null, user: { __typename?: 'CompanyUserUser', uuid: string, name: string | null, email: string }, invitation: { __typename?: 'CompanyUserInvitation', uuid: string, expiresAt: string } | null } };

export type DeleteCompanyUserMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteCompanyUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type ResendInviteMutationVariables = Exact<{
  input: ResendInviteInput;
}>;


export type ResendInviteMutation = { __typename?: 'Mutation', resendInvite: { __typename?: 'CompanyUser', uuid: string, userUuid: string, companyUuid: string, role: CompanyUserRole, createdAt: string | null, deletedAt: string | null, user: { __typename?: 'CompanyUserUser', uuid: string, name: string | null, email: string }, invitation: { __typename?: 'CompanyUserInvitation', uuid: string, expiresAt: string } | null } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptInvitationInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation: { __typename?: 'Token', accessToken: string } };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateMeInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'User', uuid: string, email: string, name: string | null, verifiedEmailAt: string | null, onboardingCompletedAt: string | null, hasPendingEmail: boolean | null, pendingEmail: string | null, role: CompanyUserRole, company: { __typename?: 'UserCompany', uuid: string, name: string | null, billingCountry: string | null, vatNumber: string | null, billingAddressLine1: string | null, billingAddressLine2: string | null, billingCity: string | null, billingPostalCode: string | null, limitations: Array<UserCompanyLimitation>, subscription: { __typename?: 'UserCompanySubscription', uuid: string, subtotal: number, type: SubscriptionType, status: SubscriptionStatus, tokenBillingType: TokenBillingType, renewsAt: string | null, expiresAt: string | null } | null, outstandingInvoice: { __typename?: 'OutstandingInvoice', uuid: string, subscriptionUuid: string | null } | null } } };

export type DeleteMeMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteMeMutation = { __typename?: 'Mutation', deleteMe: boolean };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'UserCompany', uuid: string, name: string | null } };

export type UpdateBillingDetailsMutationVariables = Exact<{
  input: BillingDetailsInput;
}>;


export type UpdateBillingDetailsMutation = { __typename?: 'Mutation', updateBillingDetails: { __typename?: 'UpdateBillingDetailsResult', removedPaymentMethods: number, company: { __typename?: 'UserCompany', uuid: string, billingCountry: string | null, vatNumber: string | null, billingAddressLine1: string | null, billingAddressLine2: string | null, billingCity: string | null, billingPostalCode: string | null, subscription: { __typename?: 'UserCompanySubscription', uuid: string, status: SubscriptionStatus } | null } } };

export type DeleteCompanyMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany: boolean };

export type IndexUserPreferencesQueryVariables = Exact<{
  input: IndexUserPreferencesInput;
}>;


export type IndexUserPreferencesQuery = { __typename?: 'Query', indexUserPreferences: Array<{ __typename?: 'UserPreference', userUuid: string, preferenceUuid: string, value: string | null, preference: { __typename?: 'Preference', uuid: string, group: PreferenceGroup, name: PreferenceName, displayName: string } }> };

export type UpdateUserPreferenceMutationVariables = Exact<{
  input: UpdateUserPreferenceInput;
}>;


export type UpdateUserPreferenceMutation = { __typename?: 'Mutation', updateUserPreference: { __typename?: 'UserPreference', userUuid: string, preferenceUuid: string, value: string | null, preference: { __typename?: 'Preference', uuid: string, group: PreferenceGroup, name: PreferenceName, displayName: string } } };

export type NotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationPreferencesQuery = { __typename?: 'Query', notificationPreferences: Array<{ __typename?: 'NotificationPreference', uuid: string, notificationType: NotificationPreferenceType, notificationValue: string | null, isWeb: boolean, isEmail: boolean }> };

export type CreateNotificationPreferenceMutationVariables = Exact<{
  input: CreateNotificationPreferenceInput;
}>;


export type CreateNotificationPreferenceMutation = { __typename?: 'Mutation', createNotificationPreference: { __typename?: 'NotificationPreference', uuid: string, notificationType: NotificationPreferenceType, notificationValue: string | null, isWeb: boolean, isEmail: boolean } };

export type UpdateNotificationPreferenceMutationVariables = Exact<{
  input: UpdateNotificationPreferenceInput;
}>;


export type UpdateNotificationPreferenceMutation = { __typename?: 'Mutation', updateNotificationPreference: { __typename?: 'NotificationPreference', uuid: string, notificationType: NotificationPreferenceType, notificationValue: string | null, isWeb: boolean, isEmail: boolean } };

export type DeleteNotificationPreferenceMutationVariables = Exact<{
  input: DeleteNotificationPreferenceInput;
}>;


export type DeleteNotificationPreferenceMutation = { __typename?: 'Mutation', deleteNotificationPreference: boolean };

export type CreateSubscriptionIntentMutationVariables = Exact<{
  input: CreateSubscriptionIntentInput;
}>;


export type CreateSubscriptionIntentMutation = { __typename?: 'Mutation', createSubscriptionIntent: { __typename?: 'PaymentResult', succeeded: boolean, clientSecret: string | null } };

export type PayInvoiceMutationVariables = Exact<{
  input: PayInvoiceInput;
}>;


export type PayInvoiceMutation = { __typename?: 'Mutation', payInvoice: { __typename?: 'PaymentResult', succeeded: boolean, clientSecret: string | null } };

export type PreviewPlanChangeQueryVariables = Exact<{
  priceStep: Scalars['Int']['input'];
}>;


export type PreviewPlanChangeQuery = { __typename?: 'Query', previewPlanChange: { __typename?: 'PlanChangePreview', discount: number, charge: number } };

export type ReadUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type ReadUsageQuery = { __typename?: 'Query', readUsage: { __typename?: 'BillingUsage', queries: { __typename?: 'UsageBalance', total: number, used: number }, pages: { __typename?: 'UsageBalance', total: number, used: number } } };

export type ListPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPaymentMethodsQuery = { __typename?: 'Query', listPaymentMethods: Array<{ __typename?: 'PaymentMethod', uuid: string, brand: string, last4: string, expMonth: number, expYear: number, useForMonthlyPlan: boolean }> };

export type CreateSetupIntentMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSetupIntentMutation = { __typename?: 'Mutation', createSetupIntent: { __typename?: 'StripeIntent', clientSecret: string } };

export type RemovePaymentMethodMutationVariables = Exact<{
  input: RemovePaymentMethodInput;
}>;


export type RemovePaymentMethodMutation = { __typename?: 'Mutation', removePaymentMethod: boolean };

export type SavePaymentMethodMutationVariables = Exact<{
  input: SavePaymentMethodInput;
}>;


export type SavePaymentMethodMutation = { __typename?: 'Mutation', savePaymentMethod: { __typename?: 'PaymentMethod', uuid: string } };

export type UpdateSubscriptionMutationVariables = Exact<{
  action: SubscriptionAction;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: boolean };

export type ListInvoicesQueryVariables = Exact<{
  input: ListInvoicesInput;
}>;


export type ListInvoicesQuery = { __typename?: 'Query', listInvoices: { __typename?: 'InvoicePage', pagination: { __typename?: 'PaginationResponse', lastPage: number }, items: Array<{ __typename?: 'Invoice', uuid: string, description: string, subscriptionType: SubscriptionType | null, currency: string, subtotal: number | null, tax: number | null, total: number | null, status: InvoiceStatus, paidAt: string | null, createdAt: string }> } };

export type ReadInvoiceQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ReadInvoiceQuery = { __typename?: 'Query', readInvoice: { __typename?: 'Invoice', uuid: string, description: string, currency: string, subtotal: number | null, tax: number | null, total: number | null, status: InvoiceStatus, paidAt: string | null, createdAt: string, stripeDetails: { __typename?: 'InvoiceStripeDetails', number: string | null, hostedInvoiceUrl: string | null, invoicePdfUrl: string | null, dueDate: string | null, paymentMethodBrand: string | null, paymentMethodLast4: string | null } | null } };

export type IndexQueryMessagesQueryVariables = Exact<{
  input: IndexQueryMessagesInput;
}>;


export type IndexQueryMessagesQuery = { __typename?: 'Query', indexQueryMessages: { __typename?: 'QueryMessagePage', lastEvaluatedKey: string | null, items: Array<{ __typename?: 'QueryMessage', uuid: string, role: QueryMessageRole, retrievalToken: string | null, status: QueryMessageStatus, createdAt: string, parts: Array<{ __typename?: 'QueryMessagePart', thought: boolean | null, text: string | null, executableCode: { __typename?: 'QueryMessagePartExecutableCode', language: string | null, code: string | null } | null }>, files: Array<{ __typename?: 'File', uuid: string, name: string, mimeType: string }>, feedback: { __typename?: 'QueryMessageFeedback', qualitative: string | null, quantitative: QuantitativeQueryMessageFeedback } | null, groundingChunks: Array<{ __typename?: 'QueryMessageGroundingChunk', uuid: string, title: string, description: string | null, url: string | null, hostedIntegrationPath: string | null, favicon: string | null, source: { __typename?: 'QueryMessageGroundingChunkSource', type: SourceType }, file: { __typename?: 'QueryMessageGroundingChunkFile', name: string } | null }>, citations: Array<{ __typename?: 'QueryMessageCitation', chunkId: string, snippet: string, startIndex: number | null, endIndex: number | null }> }> } };

export type CreateQueryMutationVariables = Exact<{
  input: CreateQueryInput;
}>;


export type CreateQueryMutation = { __typename?: 'Mutation', createQuery: { __typename?: 'CreateQueryResponse', query: { __typename?: 'ProjectQuery', uuid: string }, user: { __typename?: 'QueryMessage', uuid: string, role: QueryMessageRole, retrievalToken: string | null, status: QueryMessageStatus, createdAt: string, parts: Array<{ __typename?: 'QueryMessagePart', thought: boolean | null, text: string | null, executableCode: { __typename?: 'QueryMessagePartExecutableCode', language: string | null, code: string | null } | null }>, files: Array<{ __typename?: 'File', uuid: string, name: string, mimeType: string }>, feedback: { __typename?: 'QueryMessageFeedback', qualitative: string | null, quantitative: QuantitativeQueryMessageFeedback } | null, groundingChunks: Array<{ __typename?: 'QueryMessageGroundingChunk', uuid: string, title: string, description: string | null, url: string | null, hostedIntegrationPath: string | null, favicon: string | null, source: { __typename?: 'QueryMessageGroundingChunkSource', type: SourceType }, file: { __typename?: 'QueryMessageGroundingChunkFile', name: string } | null }>, citations: Array<{ __typename?: 'QueryMessageCitation', chunkId: string, snippet: string, startIndex: number | null, endIndex: number | null }> }, model: { __typename?: 'QueryMessage', uuid: string, role: QueryMessageRole, retrievalToken: string | null, status: QueryMessageStatus, createdAt: string, parts: Array<{ __typename?: 'QueryMessagePart', thought: boolean | null, text: string | null, executableCode: { __typename?: 'QueryMessagePartExecutableCode', language: string | null, code: string | null } | null }>, files: Array<{ __typename?: 'File', uuid: string, name: string, mimeType: string }>, feedback: { __typename?: 'QueryMessageFeedback', qualitative: string | null, quantitative: QuantitativeQueryMessageFeedback } | null, groundingChunks: Array<{ __typename?: 'QueryMessageGroundingChunk', uuid: string, title: string, description: string | null, url: string | null, hostedIntegrationPath: string | null, favicon: string | null, source: { __typename?: 'QueryMessageGroundingChunkSource', type: SourceType }, file: { __typename?: 'QueryMessageGroundingChunkFile', name: string } | null }>, citations: Array<{ __typename?: 'QueryMessageCitation', chunkId: string, snippet: string, startIndex: number | null, endIndex: number | null }> } } };

export type QueryMessageFragmentFragment = { __typename?: 'QueryMessage', uuid: string, role: QueryMessageRole, retrievalToken: string | null, status: QueryMessageStatus, createdAt: string, parts: Array<{ __typename?: 'QueryMessagePart', thought: boolean | null, text: string | null, executableCode: { __typename?: 'QueryMessagePartExecutableCode', language: string | null, code: string | null } | null }>, files: Array<{ __typename?: 'File', uuid: string, name: string, mimeType: string }>, feedback: { __typename?: 'QueryMessageFeedback', qualitative: string | null, quantitative: QuantitativeQueryMessageFeedback } | null, groundingChunks: Array<{ __typename?: 'QueryMessageGroundingChunk', uuid: string, title: string, description: string | null, url: string | null, hostedIntegrationPath: string | null, favicon: string | null, source: { __typename?: 'QueryMessageGroundingChunkSource', type: SourceType }, file: { __typename?: 'QueryMessageGroundingChunkFile', name: string } | null }>, citations: Array<{ __typename?: 'QueryMessageCitation', chunkId: string, snippet: string, startIndex: number | null, endIndex: number | null }> };

export type CreateQueryMessageMutationVariables = Exact<{
  input: CreateQueryMessageInput;
}>;


export type CreateQueryMessageMutation = { __typename?: 'Mutation', createQueryMessage: { __typename?: 'CreateQueryMessageResponse', user: { __typename?: 'QueryMessage', uuid: string, role: QueryMessageRole, retrievalToken: string | null, status: QueryMessageStatus, createdAt: string, parts: Array<{ __typename?: 'QueryMessagePart', thought: boolean | null, text: string | null, executableCode: { __typename?: 'QueryMessagePartExecutableCode', language: string | null, code: string | null } | null }>, files: Array<{ __typename?: 'File', uuid: string, name: string, mimeType: string }>, feedback: { __typename?: 'QueryMessageFeedback', qualitative: string | null, quantitative: QuantitativeQueryMessageFeedback } | null, groundingChunks: Array<{ __typename?: 'QueryMessageGroundingChunk', uuid: string, title: string, description: string | null, url: string | null, hostedIntegrationPath: string | null, favicon: string | null, source: { __typename?: 'QueryMessageGroundingChunkSource', type: SourceType }, file: { __typename?: 'QueryMessageGroundingChunkFile', name: string } | null }>, citations: Array<{ __typename?: 'QueryMessageCitation', chunkId: string, snippet: string, startIndex: number | null, endIndex: number | null }> }, model: { __typename?: 'QueryMessage', uuid: string, role: QueryMessageRole, retrievalToken: string | null, status: QueryMessageStatus, createdAt: string, parts: Array<{ __typename?: 'QueryMessagePart', thought: boolean | null, text: string | null, executableCode: { __typename?: 'QueryMessagePartExecutableCode', language: string | null, code: string | null } | null }>, files: Array<{ __typename?: 'File', uuid: string, name: string, mimeType: string }>, feedback: { __typename?: 'QueryMessageFeedback', qualitative: string | null, quantitative: QuantitativeQueryMessageFeedback } | null, groundingChunks: Array<{ __typename?: 'QueryMessageGroundingChunk', uuid: string, title: string, description: string | null, url: string | null, hostedIntegrationPath: string | null, favicon: string | null, source: { __typename?: 'QueryMessageGroundingChunkSource', type: SourceType }, file: { __typename?: 'QueryMessageGroundingChunkFile', name: string } | null }>, citations: Array<{ __typename?: 'QueryMessageCitation', chunkId: string, snippet: string, startIndex: number | null, endIndex: number | null }> } } };

export type ReadQueryMessageQueryVariables = Exact<{
  input: ReadQueryMessageInput;
}>;


export type ReadQueryMessageQuery = { __typename?: 'Query', readQueryMessage: { __typename?: 'QueryMessage', uuid: string, role: QueryMessageRole, retrievalToken: string | null, status: QueryMessageStatus, createdAt: string, parts: Array<{ __typename?: 'QueryMessagePart', thought: boolean | null, text: string | null, executableCode: { __typename?: 'QueryMessagePartExecutableCode', language: string | null, code: string | null } | null }>, files: Array<{ __typename?: 'File', uuid: string, name: string, mimeType: string }>, feedback: { __typename?: 'QueryMessageFeedback', qualitative: string | null, quantitative: QuantitativeQueryMessageFeedback } | null, groundingChunks: Array<{ __typename?: 'QueryMessageGroundingChunk', uuid: string, title: string, description: string | null, url: string | null, hostedIntegrationPath: string | null, favicon: string | null, source: { __typename?: 'QueryMessageGroundingChunkSource', type: SourceType }, file: { __typename?: 'QueryMessageGroundingChunkFile', name: string } | null }>, citations: Array<{ __typename?: 'QueryMessageCitation', chunkId: string, snippet: string, startIndex: number | null, endIndex: number | null }> } };

export type CreateFileMutationVariables = Exact<{
  input: CreateFileInput;
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createFile: Array<{ __typename?: 'CreateFile', uuid: string, src: string, uploadInstructions: { __typename?: 'UploadInstructions', url: string, key: string, keyPrefix: string } }> };

export type DeleteFileMutationVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: boolean };

export type UpdateQueryMessageMutationVariables = Exact<{
  input: UpdateQueryMessageInput;
}>;


export type UpdateQueryMessageMutation = { __typename?: 'Mutation', updateQueryMessage: boolean };

export type IndexGroundingChunksQueryVariables = Exact<{
  input: IndexGroundingChunksInput;
}>;


export type IndexGroundingChunksQuery = { __typename?: 'Query', indexGroundingChunks: Array<{ __typename?: 'QueryMessageGroundingChunk', uuid: string, title: string, url: string | null, hostedIntegrationPath: string | null, favicon: string | null, source: { __typename?: 'QueryMessageGroundingChunkSource', type: SourceType }, file: { __typename?: 'QueryMessageGroundingChunkFile', name: string } | null }> };

export type ProjectQueryListFragment = { __typename?: 'ProjectQuery', uuid: string, title: string | null, isBookmarked: boolean };

export type IndexQueriesQueryVariables = Exact<{
  input: IndexQueryInput;
}>;


export type IndexQueriesQuery = { __typename?: 'Query', indexQueries: { __typename?: 'QueryPage', items: Array<{ __typename?: 'ProjectQuery', uuid: string, title: string | null, isBookmarked: boolean }>, pagination: { __typename?: 'PaginationResponse', lastPage: number } } };

export type ProjectQueryFragment = { __typename?: 'ProjectQuery', uuid: string, title: string | null, isBookmarked: boolean, rateLimit: { __typename?: 'SessionRateLimit', queriesConsumed: number, queryMultiplier: number, queriesPerUserPerHour: number, queriesUsedThisHour: number, queriesRemaining: number, resetsAt: string | null } };

export type UpdateQueryMutationVariables = Exact<{
  input: UpdateQueryInput;
}>;


export type UpdateQueryMutation = { __typename?: 'Mutation', updateQuery: { __typename?: 'ProjectQuery', uuid: string, title: string | null, isBookmarked: boolean, rateLimit: { __typename?: 'SessionRateLimit', queriesConsumed: number, queryMultiplier: number, queriesPerUserPerHour: number, queriesUsedThisHour: number, queriesRemaining: number, resetsAt: string | null } } };

export type ReadQueryQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ReadQueryQuery = { __typename?: 'Query', readQuery: { __typename?: 'ProjectQuery', uuid: string, title: string | null, isBookmarked: boolean, rateLimit: { __typename?: 'SessionRateLimit', queriesConsumed: number, queryMultiplier: number, queriesPerUserPerHour: number, queriesUsedThisHour: number, queriesRemaining: number, resetsAt: string | null } } | null };


  import gql from "graphql-tag";
  export const typeDefs = gql`schema {
  query: Query
  mutation: Mutation
}

input AcceptInvitationInput {
  email: String!
  name: String!
  token: String!
}

input AuthorisationCodeInput {
  code: String!
  gclid: String
  state: String!
  verifier: String!
}

type AuthorisePayload {
  accessToken: String!
  registeredCompanyUuid: String
}

input BillingDetailsInput {
  addressLine1: String
  addressLine2: String
  city: String
  enteredCountry: String!
  postcode: String
  vatNumber: String
}

type BillingUsage {
  pages: UsageBalance!
  queries: UsageBalance!
}

type CompanyUser {
  companyUuid: String!
  createdAt: DateTimeISO
  deletedAt: DateTimeISO
  invitation: CompanyUserInvitation
  role: CompanyUserRole!
  user: CompanyUserUser!
  userUuid: String!
  uuid: String!
}

type CompanyUserInvitation {
  expiresAt: DateTimeISO!
  uuid: String!
}

type CompanyUserPage {
  items: [CompanyUser!]!
  pagination: PaginationResponse!
}

enum CompanyUserRole {
  accountOwner
  admin
  member
}

enum CompanyUserState {
  deleted
  expired
  invited
  joined
}

type CompanyUserUser {
  email: String!
  name: String
  uuid: String!
}

input ConfirmEmailInput {
  email: String!
  verification: String!
}

input CreateDomainInput {
  url: String!
}

type CreateFile {
  src: String!
  uploadInstructions: UploadInstructions!
  uuid: String!
}

input CreateFileInput {
  files: [CreateFileInputFiles!]!
  keyPrefix: String!
  projectUuid: String
}

input CreateFileInputFiles {
  deletedAt: DateTimeISO
  filename: String!
  mimeType: String!
  size: Int!
  uuid: String
}

input CreateIntegrationInput {
  authorisationCode: String!
  integrationType: IntegrationType!
}

input CreateInvitationForUserInput {
  email: String!
  role: CompanyUserRole!
}

input CreateNotificationPreferenceInput {
  isEmail: Boolean!
  isWeb: Boolean!
  notificationType: NotificationPreferenceType!
  notificationValue: String
}

input CreateProjectInput {
  name: String!
}

input CreateQueryInput {
  content: String!
  fileUuids: [String!]!
  projectUuid: String!
  question: String
}

input CreateQueryMessageFileInput {
  key: String!
  keyPrefix: String!
  mimeType: String!
  uuid: String!
}

input CreateQueryMessageInput {
  content: String!
  fileUuids: [String!]!
  queryUuid: String!
}

type CreateQueryMessageResponse {
  model: QueryMessage!
  user: QueryMessage!
}

type CreateQueryResponse {
  model: QueryMessage!
  query: ProjectQuery!
  user: QueryMessage!
}

input CreateSessionTokenInput {
  domainPrefix: String
  hostname: String!
  magicLink: MagicLinkInput
}

input CreateSubscriptionIntentInput {
  paymentMethodId: String
  paymentMethodUuid: String
  priceStep: Int!
  subscriptionType: SubscriptionType!
}

input CreateThemeInput {
  brandColour: String!
  logoUuid: String!
  name: String!
  subtitle: String
  themeType: ThemeType!
  title: String
}

enum DateGranularity {
  day
  month
  week
}

scalar DateTimeISO

type DateWithCount {
  count: Int!
  date: DateTimeISO!
}

input DeleteDomainInput {
  uuid: String!
}

input DeleteNotificationPreferenceInput {
  uuid: String!
}

input DeleteUserInput {
  userUuid: String!
}

input DimensionInput {
  height: Int
  width: Int!
}

type Domain {
  cloudflareStatus: String!
  createdAt: DateTimeISO!
  projectUuid: String
  url: String!
  uuid: String!
  verificationRecords: [DomainVerificationRecord!]!
}

type DomainPage {
  items: [Domain!]!
  pagination: PaginationResponse!
}

type DomainVerificationRecord {
  name: String!
  purpose: String!
  value: String!
}

enum FailedReason {
  emptyContent
  extraction
  invalidIntegrationDoucment
}

type File {
  createdAt: DateTimeISO!
  downloadSrc: String!
  key: String!
  keyPrefix: String
  mimeType: String!
  name: String!
  size: Int!
  src(input: DimensionInput): String!
  uuid: String!
}

input IndexDomainsFilterInput {
  unallocated: Boolean
}

input IndexDomainsInput {
  filters: IndexDomainsFilterInput
  pagination: PaginationInput!
}

input IndexGroundingChunksInput {
  message: ReadQueryMessageInput!
  queryUuid: String!
}

input IndexIntegrationDocumentsInput {
  nextPageToken: String
  pathSegments: [IntegrationDocumentsPagePathSegmentInput!]!
  query: String
  type: IntegrationType!
}

input IndexIntegrationInput {
  pagination: PaginationInput
}

input IndexProjectsInput {
  filter: IndexProjectsInputFilter!
  pagination: PaginationInput
}

input IndexProjectsInputFilter {
  state: ProjectState
}

input IndexQueryInput {
  filter: IndexQueryInputFilter!
  pagination: PaginationInput!
}

input IndexQueryInputFilter {
  isBookmarked: Boolean
  projectUuid: String!
}

input IndexQueryMessagesFilter {
  queryUuid: String!
}

input IndexQueryMessagesInput {
  filter: IndexQueryMessagesFilter!
  lastEvaluatedKey: String
}

input IndexSourceDocumentsInput {
  filter: ReadSourceDocumentsFilter!
  pagination: PaginationInput!
}

input IndexThemesInput {
  pagination: PaginationInput
}

input IndexUserPreferencesInput {
  filter: IndexUserPreferencesInputFilter!
}

input IndexUserPreferencesInputFilter {
  group: PreferenceGroup
}

input IndexUsersInput {
  filter: IndexUsersInputFilter!
  pagination: PaginationInput
}

input IndexUsersInputFilter {
  state: CompanyUserState
}

type Integration {
  state: IntegrationState!
  type: IntegrationType!
  uuid: String!
}

type IntegrationDocument {
  hasChildren: Boolean!
  id: String!
  mimeType: String!
  name: String!
  pathSegments: [IntegrationDocumentsPagePathSegment!]!
  relevance: DateTimeISO!
  type: String!
}

type IntegrationDocumentsPage {
  items: [IntegrationDocument!]!
  nextPageToken: String
  pathSegments: [IntegrationDocumentsPagePathSegment!]!
  totalPages: Int
}

type IntegrationDocumentsPagePathSegment {
  id: String!
  name: String!
  type: String
}

input IntegrationDocumentsPagePathSegmentInput {
  id: String!
  name: String!
  type: String
}

type IntegrationPage {
  items: [Integration!]!
  pagination: PaginationResponse!
}

type IntegrationSelectionResolution {
  count: Int!
}

enum IntegrationState {
  authorised
  declined
  expired
  new
}

enum IntegrationType {
  dropbox
  googleDrive
  notion
}

type Invoice {
  createdAt: DateTimeISO!
  currency: String!
  description: String!
  paidAt: DateTimeISO
  status: InvoiceStatus!
  stripeDetails: InvoiceStripeDetails
  subscriptionType: SubscriptionType
  subtotal: Float
  tax: Float
  total: Float
  uuid: String!
}

type InvoicePage {
  items: [Invoice!]!
  pagination: PaginationResponse!
}

enum InvoiceStatus {
  draft
  open
  paid
  uncollectible
  void
}

type InvoiceStripeDetails {
  dueDate: DateTimeISO
  hostedInvoiceUrl: String
  invoicePdfUrl: String
  number: String
  paymentMethodBrand: String
  paymentMethodLast4: String
}

input ListInvoicesInput {
  pagination: PaginationInput
}

input MagicLinkInput {
  token: String!
}

type Mutation {
  acceptInvitation(input: AcceptInvitationInput!): Token!
  authoriseWithAuthorisationCode(input: AuthorisationCodeInput!): AuthorisePayload!
  confirmEmail(input: ConfirmEmailInput!): Boolean!
  createDomain(input: CreateDomainInput!): Domain!
  createFile(input: CreateFileInput!): [CreateFile!]!
  createIntegration(input: CreateIntegrationInput!): Boolean
  createInvitationForUser(input: CreateInvitationForUserInput!): CompanyUser!
  createNotificationPreference(input: CreateNotificationPreferenceInput!): NotificationPreference!
  createProject(input: CreateProjectInput!): Project!
  createQuery(input: CreateQueryInput!): CreateQueryResponse!
  createQueryMessage(input: CreateQueryMessageInput!): CreateQueryMessageResponse!
  createSessionToken(input: CreateSessionTokenInput!): SessionToken!
  createSetupIntent: StripeIntent!
  createSubscriptionIntent(input: CreateSubscriptionIntentInput!): PaymentResult!
  createTheme(input: CreateThemeInput!): Theme!
  deleteCompany: Boolean!
  deleteDomain(input: DeleteDomainInput!): Boolean!
  deleteFile(uuid: String!): Boolean!
  deleteMe: Boolean!
  deleteNotificationPreference(input: DeleteNotificationPreferenceInput!): Boolean!
  deleteTheme(uuid: String!): Boolean!
  deleteUser(input: DeleteUserInput!): Boolean!
  generateProjectQuestions(projectUuid: String!): Project!
  payInvoice(input: PayInvoiceInput!): PaymentResult!
  register(input: RegisterInput!): RegisterPayload!
  removePaymentMethod(input: RemovePaymentMethodInput!): Boolean!
  requestLoginMagicLink(input: RequestLoginMagicLinkInput!): Boolean!
  requestMagicLink(input: RequestMagicLinkInput!): Boolean!
  resendInvite(input: ResendInviteInput!): CompanyUser!
  resendVerificationEmail: Boolean!
  resolveIntegrationSelection(input: ResolveIntegrationSelectionInput!): IntegrationSelectionResolution!
  savePaymentMethod(input: SavePaymentMethodInput!): PaymentMethod!
  sendDomainVerificationEmail(input: SendDomainVerificationEmailInput!): Boolean!
  updateBillingDetails(input: BillingDetailsInput!): UpdateBillingDetailsResult!
  updateCompany(input: UpdateCompanyInput!): UserCompany!
  updateMe(input: UpdateMeInput!): User!
  updateNotification(input: UpdateNotificationInput!): Notification!
  updateNotificationPreference(input: UpdateNotificationPreferenceInput!): NotificationPreference!
  updateProject(input: UpdateProjectInput!): Project!
  updateQuery(input: UpdateQueryInput!): ProjectQuery!
  updateQueryMessage(input: UpdateQueryMessageInput!): Boolean!
  updateRateLimit(input: UpdateRateLimit!): ProjectRateLimit!
  updateSource(input: UpdateSourceInput!): Source!
  updateSourceDocuments(input: UpdateSourceDocumentsInput!): Boolean!
  updateSubscription(action: SubscriptionAction!): Boolean!
  updateTheme(input: UpdateThemeInput!): Theme!
  updateUser(input: UpdateUserInput!): CompanyUser!
  updateUserPreference(input: UpdateUserPreferenceInput!): UserPreference!
  verifyLoginMagicLink(input: VerifyLoginMagicLinkInput!): Token!
}

type Notification {
  createdAt: DateTimeISO!
  description: String!
  isDismissed: Boolean!
  isViewed: Boolean!
  path: String!
  title: String!
  uuid: String!
}

type NotificationPreference {
  isEmail: Boolean!
  isWeb: Boolean!
  notificationType: NotificationPreferenceType!
  notificationValue: String
  uuid: String!
}

enum NotificationPreferenceType {
  creditConsumption
  projectReady
}

type OutstandingInvoice {
  subscriptionUuid: String
  uuid: String!
}

input PaginationCursorInput {
  perPage: Int!
  token: String
}

type PaginationCursorResponse {
  nextPageToken: String
}

input PaginationInput {
  page: Int!
  perPage: Int!
}

type PaginationResponse {
  currentPage: Int!
  from: Int!
  lastPage: Int!
  perPage: Int!
  to: Int!
  total: Int!
}

input PayInvoiceInput {
  invoiceUuid: String!
  paymentMethodId: String
  paymentMethodUuid: String
}

type PaymentMethod {
  brand: String!
  expMonth: Int!
  expYear: Int!
  last4: String!
  useForMonthlyPlan: Boolean!
  uuid: String!
}

type PaymentResult {
  clientSecret: String
  succeeded: Boolean!
}

type PlanChangePreview {
  charge: Float!
  discount: Float!
}

type Preference {
  displayName: String!
  group: PreferenceGroup!
  name: PreferenceName!
  uuid: String!
}

enum PreferenceGroup {
  hints
  legal
}

enum PreferenceName {
  configureSources
  terms
}

type Project {
  createdAt: DateTimeISO!
  dailyQueryCount: Int!
  domainPrefix: String!
  domains: [ProjectDomain!]!
  name: String!
  processedAt: DateTimeISO
  processedPc: Float!
  questions: [ProjectQuestion!]!
  rules: [ProjectRule!]!
  sourceCount: Int!
  state: ProjectState!
  subtitle: String
  theme: ProjectTheme
  title: String
  uuid: String!
}

type ProjectDomain {
  url: String!
  uuid: String!
}

type ProjectPage {
  items: [Project!]!
  pagination: PaginationResponse!
}

type ProjectQuery {
  isBookmarked: Boolean!
  rateLimit: SessionRateLimit!
  title: String
  uuid: String!
}

type ProjectQuestion {
  question: String!
  uuid: String!
}

type ProjectRateLimit {
  queriesPerUserPerHour: Int!
  queryMultiplier: Int!
  uuid: String!
}

type ProjectRule {
  type: ProjectRuleType!
  uuid: String!
  value: String!
}

enum ProjectRuleType {
  domain
  email
  visibility
}

enum ProjectState {
  archived
  draft
  published
  publishing
}

type ProjectTheme {
  brandColour: String!
  logoSrc: String!
  name: String!
  subtitle: String
  themeType: ThemeType!
  title: String
  uuid: String!
}

enum QuantitativeQueryMessageFeedback {
  correct
  incorrect
}

type Query {
  countQueries(dates: [DateTimeISO!]!, granularity: DateGranularity, unique: Boolean): [DateWithCount!]!
  countUsageSummary: UsageSummary!
  indexDomains(input: IndexDomainsInput!): DomainPage!
  indexGroundingChunks(input: IndexGroundingChunksInput!): [QueryMessageGroundingChunk!]!
  indexIntegrationDocuments(input: IndexIntegrationDocumentsInput!): IntegrationDocumentsPage!
  indexIntegrations(input: IndexIntegrationInput): IntegrationPage!
  indexNotifications: [Notification!]!
  indexProjects(input: IndexProjectsInput!): ProjectPage!
  indexQueries(input: IndexQueryInput!): QueryPage!
  indexQueryMessages(input: IndexQueryMessagesInput!): QueryMessagePage!
  indexSourceDocuments(input: IndexSourceDocumentsInput!): SourceDocumentPage!
  indexSources(projectUuid: String!): [Source!]!
  indexThemes(input: IndexThemesInput!): ThemePage!
  indexUserPreferences(input: IndexUserPreferencesInput!): [UserPreference!]!
  indexUsers(input: IndexUsersInput!): CompanyUserPage!
  listInvoices(input: ListInvoicesInput!): InvoicePage!
  listPaymentMethods: [PaymentMethod!]!
  logout: Boolean!
  me: User!
  notificationPreferences: [NotificationPreference!]!
  previewPlanChange(priceStep: Int!): PlanChangePreview!
  readChatQuestions: [String!]!
  readDomain(uuid: String!): Domain!
  readIntegration(type: IntegrationType!): Integration
  readIntegrationAccessToken(type: IntegrationType!): String
  readInvoice(uuid: String!): Invoice!
  readProject(createdAt: DateTimeISO, uuid: String!): Project!
  readQuery(uuid: String!): ProjectQuery
  readQueryMessage(input: ReadQueryMessageInput!): QueryMessage!
  readRateLimit(projectUuid: String!): ProjectRateLimit!
  readSource(input: ReadSourceInput!): Source!
  readTheme(uuid: String!): Theme!
  readUsage: BillingUsage!
}

type QueryMessage {
  citations: [QueryMessageCitation!]!
  createdAt: DateTimeISO!
  feedback: QueryMessageFeedback
  files: [File!]!
  groundingChunks: [QueryMessageGroundingChunk!]!
  parts: [QueryMessagePart!]!
  retrievalToken: String
  role: QueryMessageRole!
  status: QueryMessageStatus!
  uuid: String!
}

type QueryMessageCitation {
  chunkId: String!
  endIndex: Int
  snippet: String!
  startIndex: Int
}

type QueryMessageFeedback {
  qualitative: String
  quantitative: QuantitativeQueryMessageFeedback!
}

type QueryMessageGroundingChunk {
  description: String
  favicon: String
  file: QueryMessageGroundingChunkFile
  hostedIntegrationPath: String
  source: QueryMessageGroundingChunkSource!
  title: String!
  url: String
  uuid: String!
}

type QueryMessageGroundingChunkFile {
  name: String!
}

type QueryMessageGroundingChunkSource {
  type: SourceType!
}

type QueryMessagePage {
  items: [QueryMessage!]!
  lastEvaluatedKey: String
}

type QueryMessagePart {
  executableCode: QueryMessagePartExecutableCode
  text: String
  thought: Boolean
}

type QueryMessagePartExecutableCode {
  code: String
  language: String
}

enum QueryMessageRole {
  model
  user
}

enum QueryMessageStatus {
  completed
  failed
  new
  processing
  stopped
}

type QueryPage {
  items: [ProjectQuery!]!
  pagination: PaginationResponse!
}

input ReadQueryMessageInput {
  createdAt: DateTimeISO!
  uuid: String!
}

input ReadSourceDocumentsFilter {
  sourceUuid: String!
}

input ReadSourceInput {
  projectUuid: String!
  type: SourceType!
}

input RegisterInput {
  email: String!
  gclid: String
}

type RegisterPayload {
  accessToken: String!
  companyUuid: String!
}

input RemovePaymentMethodInput {
  paymentMethodUuid: String!
}

input RequestLoginMagicLinkInput {
  email: String!
  """
  Binds the link to the requesting browser. Omitted when the browser cannot
  persist the nonce cookie, in which case the link is redeemable anywhere.
  """
  nonce: String
}

input RequestMagicLinkInput {
  domainPrefix: String
  email: String!
  hostname: String!
}

input ResendInviteInput {
  userUuid: String!
}

input ResolveIntegrationSelectionInput {
  documentType: String!
  id: String!
  sourceUuid: String!
  type: IntegrationType!
}

input SavePaymentMethodInput {
  billingDetails: BillingDetailsInput
  paymentMethodId: String
  paymentMethodUuid: String
  useForMonthlyPlan: Boolean
}

input SendDomainVerificationEmailInput {
  email: String!
  uuid: String!
}

type SessionRateLimit {
  queriesConsumed: Float!
  queriesPerUserPerHour: Int!
  queriesRemaining: Int!
  queriesUsedThisHour: Int!
  queryMultiplier: Int!
  resetsAt: DateTimeISO
}

type SessionToken {
  accessToken: String!
}

type Source {
  documentCount: Int!
  name: String
  type: SourceType!
  uuid: String!
}

type SourceDocument {
  description: String
  failedAt: DateTimeISO
  failedReason: FailedReason
  file: File
  hostedIntegrationDocumentId: String
  hostedIntegrationPath: String
  processedAt: DateTimeISO
  thumbnail: File
  title: String!
  url: String
  uuid: String!
}

type SourceDocumentPage {
  items: [SourceDocument!]!
  pagination: PaginationResponse!
}

enum SourceType {
  dropbox
  file
  googleDrive
  notion
  url
}

type StripeIntent {
  clientSecret: String!
}

enum SubscriptionAction {
  cancel
  pause
  resume
  uncancel
}

enum SubscriptionStatus {
  active
  canceled
  incomplete
  incomplete_expired
  past_due
  paused
  trialing
  unpaid
}

enum SubscriptionType {
  enterprise
  essentials
}

type Theme {
  brandColour: String!
  createdAt: DateTimeISO!
  logo: File!
  name: String!
  projectCount: Int!
  subtitle: String
  themeType: ThemeType!
  title: String
  used: Boolean!
  uuid: String!
}

type ThemePage {
  items: [Theme!]!
  pagination: PaginationResponse!
}

enum ThemeType {
  dark
  light
}

type Token {
  accessToken: String!
}

enum TokenBillingType {
  invoice
  subscription
}

type UpdateBillingDetailsResult {
  company: UserCompany!
  removedPaymentMethods: Int!
}

input UpdateCompanyInput {
  name: String!
}

input UpdateMeInput {
  email: String
  name: String
}

input UpdateNotificationInput {
  isDismissed: Boolean
  isViewed: Boolean
  uuid: String!
}

input UpdateNotificationPreferenceInput {
  isEmail: Boolean!
  isWeb: Boolean!
  uuid: String!
}

input UpdateProjectInput {
  customDomainUuids: [String!]
  name: String
  questions: [UpdateProjectQuestionInput!]
  rules: [UpdateProjectRuleInput!]
  state: ProjectState
  subtitle: String
  themeUuid: String
  title: String
  uuid: String!
}

input UpdateProjectQuestionInput {
  question: String!
}

input UpdateProjectRuleInput {
  type: ProjectRuleType!
  value: String!
}

input UpdateQueryInput {
  generateTitle: String
  isBookmarked: Boolean
  uuid: String!
}

input UpdateQueryMessageInput {
  createdAt: DateTimeISO!
  feedback: QuantitativeQueryMessageFeedback
  queryUuid: String!
  uuid: String!
}

input UpdateRateLimit {
  projectUuid: String!
  queriesPerUserPerHour: Int
  queryMultiplier: Int
}

input UpdateSourceDocumentsDocumentInput {
  description: String
  fileUuid: String
  hostedIntegrationDocumentId: String
  hostedIntegrationDocumentPath: String
  hostedIntegrationMimeType: String
  relevance: DateTimeISO!
  thumbnailUuid: String
  title: String!
  url: String
}

input UpdateSourceDocumentsInput {
  documentsToCreate: [UpdateSourceDocumentsDocumentInput!]!
  documentsToDelete: [String!]!
  integrationType: IntegrationType
  uuid: String!
}

input UpdateSourceInput {
  name: String
  uuid: String!
}

input UpdateThemeInput {
  brandColour: String
  logoUuid: String
  name: String
  subtitle: String
  themeType: ThemeType
  title: String
  uuid: String!
}

input UpdateUserInput {
  email: String
  name: String
  role: CompanyUserRole
  userUuid: String!
}

input UpdateUserPreferenceInput {
  group: PreferenceGroup!
  name: PreferenceName!
  value: String
}

type UploadInstructions {
  key: String!
  keyPrefix: String!
  url: String!
}

type UsageBalance {
  total: Int!
  used: Int!
}

type UsageSummary {
  pages: UsageSummaryMetric!
  queries: UsageSummaryMetric!
  users: UsageSummaryMetric!
}

type UsageSummaryMetric {
  current: Int!
  previous: Int!
  sparkline: [Int!]!
}

type User {
  company: UserCompany!
  email: String!
  hasPendingEmail: Boolean
  name: String
  onboardingCompletedAt: DateTimeISO
  pendingEmail: String
  role: CompanyUserRole!
  unreadNotificationCount: Int!
  uuid: String!
  verifiedEmailAt: DateTimeISO
}

type UserCompany {
  billingAddressLine1: String
  billingAddressLine2: String
  billingCity: String
  billingCountry: String
  billingPostalCode: String
  limitations: [UserCompanyLimitation!]!
  name: String
  outstandingInvoice: OutstandingInvoice
  subscription: UserCompanySubscription
  uuid: String!
  vatNumber: String
}

enum UserCompanyLimitation {
  cannotCreateDomain
  cannotCreateProject
  cannotCreateQueryMessage
  cannotCreateSourceDocument
}

type UserCompanySubscription {
  expiresAt: DateTimeISO
  renewsAt: DateTimeISO
  status: SubscriptionStatus!
  subtotal: Float!
  tokenBillingType: TokenBillingType!
  type: SubscriptionType!
  uuid: String!
}

type UserPreference {
  preference: Preference!
  preferenceUuid: String!
  userUuid: String!
  value: String
}

input VerifyLoginMagicLinkInput {
  nonce: String
  token: String!
}`;
